// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/images/checkers.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.1.10 | MIT License | https://tailwindcss.com */
@layer properties;
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
      "Courier New", monospace;
    --color-red-500: oklch(63.7% 0.237 25.331);
    --color-red-600: oklch(57.7% 0.245 27.325);
    --color-blue-500: oklch(62.3% 0.214 259.815);
    --color-blue-600: oklch(54.6% 0.245 262.881);
    --color-gray-50: #F2F2F3;
    --color-gray-100: #E4E5E7;
    --color-gray-200: #CACBCE;
    --color-gray-300: #B0B2B6;
    --color-gray-500: #7B7E85;
    --color-gray-700: #4A4C50;
    --color-gray-800: #313235;
    --color-gray-900: #19191B;
    --color-black: #000000;
    --color-white: #FFFFFF;
    --spacing: 0.25rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-3xl: 1.875rem;
    --text-3xl--line-height: calc(2.25 / 1.875);
    --text-5xl: 3rem;
    --text-5xl--line-height: 1;
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --leading-tight: 1.25;
    --leading-normal: 1.5;
    --leading-loose: 2;
    --radius-sm: 0.25rem;
    --radius-md: 0.375rem;
    --radius-lg: 0.5rem;
    --radius-xl: 0.75rem;
    --radius-2xl: 1rem;
    --ease-in: cubic-bezier(0.4, 0, 1, 1);
    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
    --animate-spin: spin 1s linear infinite;
    --blur-lg: 16px;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
    --color-bgPrimaryBase: var(--color-white);
    --color-bgSecondary: var(--color-gray-50);
    --color-bgTertiary: var(--color-gray-100);
    --color-bgError: var(--color-error-100);
    --color-bgWarning: var(--color-warning-100);
    --color-textPrimary: var(--color-gray-900);
    --color-textSecondary: var(--color-gray-700);
    --color-textTertiary: var(--color-gray-500);
    --color-textLink: var(--color-primary-500);
    --color-textLinkHover: var(--color-primary-600);
    --color-textLinkPressed: var(--color-primary-700);
    --color-textDisabled: var(--color-gray-200);
    --color-textError: var(--color-error-500);
    --color-textOnColor: var(--color-white);
    --color-btnPrimary: var(--color-primary-500);
    --color-btnPrimaryHover: var(--color-primary-600);
    --color-btnPrimaryPressed: var(--color-primary-700);
    --color-btnDisabled: var(--color-gray-50);
    --color-btnSecondary: var(--color-white);
    --color-btnSecondaryBorder: var(--color-gray-200);
    --color-btnSecondaryHover: var(--color-gray-50);
    --color-btnSecondaryPressed: var(--color-gray-100);
    --color-btnTertiary: var(--color-primary-50);
    --color-btnTertiaryHover: var(--color-primary-100);
    --color-btnTertiaryPressed: var(--color-primary-100);
    --color-btnGhostPrimaryHover: var(--color-gray-50);
    --color-btnGhostPrimaryPressed: var(--color-gray-100);
    --color-inputBasePrimary: var(--color-white);
    --color-inputBorder: var(--color-gray-200);
    --color-inputBorderHover: var(--color-gray-300);
    --color-inputBorderInteractive: var(--color-primary-500);
    --color-inputBorderDisabled: var(--color-gray-150);
    --color-border200: var(--color-gray-150);
    --color-borderDisabled: var(--color-gray-150);
    --color-borderInteractive: var(--color-primary-500);
    --color-iconPrimary: var(--color-primary-500);
    --color-iconSecondary: var(--color-gray-700);
    --color-iconTertiary: var(--color-gray-300);
    --color-iconOnColor: var(--color-white);
    --color-iconDisabled: var(--color-gray-150);
    --color-iconError: var(--color-error-500);
    --color-iconSuccess: var(--color-success-500);
    --color-divider00: var(--color-gray-100);
    --color-divider01: var(--color-gray-150);
    --color-divider03: var(--color-gray-300);
    --color-tagSoftPrimaryText: var(--color-primary-500);
    --color-tagSoftPrimaryBg: var(--color-primary-100);
    --color-tagSoftGrayText: var(--color-gray-900);
    --color-tagSoftGrayBg: var(--color-gray-50);
    --color-tagSoftPrimaryIcon: var(--color-primary-700);
    --color-brandPrimary: var(--brand-primary);
    --color-brandPrimaryHover: var(--brand-primary-hover);
    --color-brandPrimaryPressed: var(--brand-primary-pressed);
    --color-brandSecondary: var(--brand-secondary);
    --color-brandSecondaryHover: var(--brand-secondary-hover);
    --color-brandSecondaryPressed: var(--brand-secondary-pressed);
    --color-brandTextPrimary: var(--brand-text-primary);
    --color-brandTextSecondary: var(--brand-text-secondary);
    --color-brandTextLink: var(--brand-text-link);
    --color-brandTextLinkHover: var(--brand-text-link-hover);
    --color-brandTextLinkPressed: var(--brand-text-link-pressed);
    --color-alpha-gray-1: #FFFFFF03;
    --color-gray-150: #D7D8DA;
    --color-primary-50: #EFF8FE;
    --color-primary-100: #DFF1FD;
    --color-primary-200: #B9E5FC;
    --color-primary-500: #00A0FF;
    --color-primary-600: #0286CA;
    --color-primary-700: #0368A0;
    --color-error-100: #FFE5E3;
    --color-error-500: #EB4143;
    --color-warning-100: #FEF2C7;
    --color-warning-500: #F6970A;
    --color-success-100: #D8F9E1;
    --color-success-500: #26BF56;
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .pointer-events-none {
    pointer-events: none;
  }
  .invisible {
    visibility: hidden;
  }
  .visible {
    visibility: visible;
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .static {
    position: static;
  }
  .sticky {
    position: sticky;
  }
  .inset-0 {
    inset: calc(var(--spacing) * 0);
  }
  .-top-4 {
    top: calc(var(--spacing) * -4);
  }
  .top-0 {
    top: calc(var(--spacing) * 0);
  }
  .top-0\\.5 {
    top: calc(var(--spacing) * 0.5);
  }
  .top-1 {
    top: calc(var(--spacing) * 1);
  }
  .top-2 {
    top: calc(var(--spacing) * 2);
  }
  .top-\\[5\\.5px\\] {
    top: 5.5px;
  }
  .top-\\[7px\\] {
    top: 7px;
  }
  .top-\\[20px\\] {
    top: 20px;
  }
  .top-\\[84px\\] {
    top: 84px;
  }
  .top-\\[calc\\(50\\%-var\\(--layout-header-height\\)\\)\\] {
    top: calc(50% - var(--layout-header-height));
  }
  .-right-4 {
    right: calc(var(--spacing) * -4);
  }
  .right-0 {
    right: calc(var(--spacing) * 0);
  }
  .right-1\\.5 {
    right: calc(var(--spacing) * 1.5);
  }
  .right-5 {
    right: calc(var(--spacing) * 5);
  }
  .right-\\[34px\\] {
    right: 34px;
  }
  .bottom-0 {
    bottom: calc(var(--spacing) * 0);
  }
  .bottom-5 {
    bottom: calc(var(--spacing) * 5);
  }
  .-left-4 {
    left: calc(var(--spacing) * -4);
  }
  .left-0 {
    left: calc(var(--spacing) * 0);
  }
  .left-0\\.5 {
    left: calc(var(--spacing) * 0.5);
  }
  .left-1 {
    left: calc(var(--spacing) * 1);
  }
  .left-1\\.5 {
    left: calc(var(--spacing) * 1.5);
  }
  .left-1\\/2 {
    left: calc(1/2 * 100%);
  }
  .left-5 {
    left: calc(var(--spacing) * 5);
  }
  .left-\\[-9999px\\] {
    left: -9999px;
  }
  .left-full {
    left: 100%;
  }
  .-z-10 {
    z-index: calc(10 * -1);
  }
  .z-10 {
    z-index: 10;
  }
  .z-11 {
    z-index: 11;
  }
  .z-50 {
    z-index: 50;
  }
  .z-60 {
    z-index: 60;
  }
  .\\!col-span-1 {
    grid-column: span 1 / span 1 !important;
  }
  .\\!col-span-2 {
    grid-column: span 2 / span 2 !important;
  }
  .col-span-2 {
    grid-column: span 2 / span 2;
  }
  .col-start-1 {
    grid-column-start: 1;
  }
  .col-end-3 {
    grid-column-end: 3;
  }
  .float-left {
    float: left;
  }
  .float-right {
    float: right;
  }
  .container {
    width: 100%;
    @media (width >= 40rem) {
      max-width: 40rem;
    }
    @media (width >= 48rem) {
      max-width: 48rem;
    }
    @media (width >= 64rem) {
      max-width: 64rem;
    }
    @media (width >= 80rem) {
      max-width: 80rem;
    }
    @media (width >= 96rem) {
      max-width: 96rem;
    }
  }
  .\\!m-0 {
    margin: calc(var(--spacing) * 0) !important;
  }
  .m-0 {
    margin: calc(var(--spacing) * 0);
  }
  .m-1 {
    margin: calc(var(--spacing) * 1);
  }
  .m-\\[var\\(--sidebar-padding\\)\\] {
    margin: var(--sidebar-padding);
  }
  .m-auto {
    margin: auto;
  }
  .\\!my-\\[-4px\\] {
    margin-block: -4px !important;
  }
  .my-0 {
    margin-block: calc(var(--spacing) * 0);
  }
  .my-2 {
    margin-block: calc(var(--spacing) * 2);
  }
  .my-3 {
    margin-block: calc(var(--spacing) * 3);
  }
  .my-3\\.5 {
    margin-block: calc(var(--spacing) * 3.5);
  }
  .my-4 {
    margin-block: calc(var(--spacing) * 4);
  }
  .mt-0 {
    margin-top: calc(var(--spacing) * 0);
  }
  .mt-1 {
    margin-top: calc(var(--spacing) * 1);
  }
  .mt-2 {
    margin-top: calc(var(--spacing) * 2);
  }
  .mt-2\\! {
    margin-top: calc(var(--spacing) * 2) !important;
  }
  .mt-2\\.5 {
    margin-top: calc(var(--spacing) * 2.5);
  }
  .mt-3 {
    margin-top: calc(var(--spacing) * 3);
  }
  .mt-3\\! {
    margin-top: calc(var(--spacing) * 3) !important;
  }
  .mt-3\\.5 {
    margin-top: calc(var(--spacing) * 3.5);
  }
  .mt-4 {
    margin-top: calc(var(--spacing) * 4);
  }
  .mt-6 {
    margin-top: calc(var(--spacing) * 6);
  }
  .mt-7 {
    margin-top: calc(var(--spacing) * 7);
  }
  .mt-8 {
    margin-top: calc(var(--spacing) * 8);
  }
  .mt-9 {
    margin-top: calc(var(--spacing) * 9);
  }
  .mt-10 {
    margin-top: calc(var(--spacing) * 10);
  }
  .mt-12 {
    margin-top: calc(var(--spacing) * 12);
  }
  .mt-\\[-5px\\] {
    margin-top: -5px;
  }
  .mt-\\[-20px\\] {
    margin-top: -20px;
  }
  .mt-\\[16px\\] {
    margin-top: 16px;
  }
  .mr-0\\.5 {
    margin-right: calc(var(--spacing) * 0.5);
  }
  .mr-1 {
    margin-right: calc(var(--spacing) * 1);
  }
  .mr-2 {
    margin-right: calc(var(--spacing) * 2);
  }
  .mr-3 {
    margin-right: calc(var(--spacing) * 3);
  }
  .mr-auto {
    margin-right: auto;
  }
  .mb-0 {
    margin-bottom: calc(var(--spacing) * 0);
  }
  .mb-0\\.5 {
    margin-bottom: calc(var(--spacing) * 0.5);
  }
  .mb-1 {
    margin-bottom: calc(var(--spacing) * 1);
  }
  .mb-1\\.5 {
    margin-bottom: calc(var(--spacing) * 1.5);
  }
  .mb-2 {
    margin-bottom: calc(var(--spacing) * 2);
  }
  .mb-2\\.5 {
    margin-bottom: calc(var(--spacing) * 2.5);
  }
  .mb-3 {
    margin-bottom: calc(var(--spacing) * 3);
  }
  .mb-4 {
    margin-bottom: calc(var(--spacing) * 4);
  }
  .mb-5 {
    margin-bottom: calc(var(--spacing) * 5);
  }
  .mb-5\\! {
    margin-bottom: calc(var(--spacing) * 5) !important;
  }
  .mb-6 {
    margin-bottom: calc(var(--spacing) * 6);
  }
  .mb-6\\! {
    margin-bottom: calc(var(--spacing) * 6) !important;
  }
  .mb-7 {
    margin-bottom: calc(var(--spacing) * 7);
  }
  .mb-7\\.5 {
    margin-bottom: calc(var(--spacing) * 7.5);
  }
  .mb-9 {
    margin-bottom: calc(var(--spacing) * 9);
  }
  .-ml-3 {
    margin-left: calc(var(--spacing) * -3);
  }
  .ml-0\\.5 {
    margin-left: calc(var(--spacing) * 0.5);
  }
  .ml-1\\.5 {
    margin-left: calc(var(--spacing) * 1.5);
  }
  .ml-2 {
    margin-left: calc(var(--spacing) * 2);
  }
  .ml-2\\.5 {
    margin-left: calc(var(--spacing) * 2.5);
  }
  .ml-3 {
    margin-left: calc(var(--spacing) * 3);
  }
  .ml-\\[-4px\\] {
    margin-left: -4px;
  }
  .ml-\\[10px\\] {
    margin-left: 10px;
  }
  .box-border {
    box-sizing: border-box;
  }
  .line-clamp-2 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .\\!flex {
    display: flex !important;
  }
  .block {
    display: block;
  }
  .contents {
    display: contents;
  }
  .flex {
    display: flex;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .inline {
    display: inline;
  }
  .inline-block {
    display: inline-block;
  }
  .inline-flex {
    display: inline-flex;
  }
  .table {
    display: table;
  }
  .h-0 {
    height: calc(var(--spacing) * 0);
  }
  .h-1 {
    height: calc(var(--spacing) * 1);
  }
  .h-1\\.5 {
    height: calc(var(--spacing) * 1.5);
  }
  .h-2 {
    height: calc(var(--spacing) * 2);
  }
  .h-2\\.5 {
    height: calc(var(--spacing) * 2.5);
  }
  .h-3 {
    height: calc(var(--spacing) * 3);
  }
  .h-4 {
    height: calc(var(--spacing) * 4);
  }
  .h-4\\.5 {
    height: calc(var(--spacing) * 4.5);
  }
  .h-5 {
    height: calc(var(--spacing) * 5);
  }
  .h-6 {
    height: calc(var(--spacing) * 6);
  }
  .h-8 {
    height: calc(var(--spacing) * 8);
  }
  .h-9 {
    height: calc(var(--spacing) * 9);
  }
  .h-10 {
    height: calc(var(--spacing) * 10);
  }
  .h-14 {
    height: calc(var(--spacing) * 14);
  }
  .h-17\\.5 {
    height: calc(var(--spacing) * 17.5);
  }
  .h-32 {
    height: calc(var(--spacing) * 32);
  }
  .h-\\[1px\\] {
    height: 1px;
  }
  .h-\\[11px\\] {
    height: 11px;
  }
  .h-\\[14px\\] {
    height: 14px;
  }
  .h-\\[15px\\] {
    height: 15px;
  }
  .h-\\[19px\\] {
    height: 19px;
  }
  .h-\\[32px\\] {
    height: 32px;
  }
  .h-\\[37px\\] {
    height: 37px;
  }
  .h-\\[38px\\] {
    height: 38px;
  }
  .h-\\[70px\\] {
    height: 70px;
  }
  .h-\\[105px\\] {
    height: 105px;
  }
  .h-\\[250px\\] {
    height: 250px;
  }
  .h-\\[580px\\] {
    height: 580px;
  }
  .h-\\[600px\\] {
    height: 600px;
  }
  .h-\\[660px\\] {
    height: 660px;
  }
  .h-\\[calc\\(100\\%-10px\\)\\] {
    height: calc(100% - 10px);
  }
  .h-\\[calc\\(100vh-190px\\)\\] {
    height: calc(100vh - 190px);
  }
  .h-\\[calc\\(100vh-var\\(--layout-header-height\\)\\)\\] {
    height: calc(100vh - var(--layout-header-height));
  }
  .h-\\[inherit\\] {
    height: inherit;
  }
  .h-auto {
    height: auto;
  }
  .h-fit {
    height: fit-content;
  }
  .h-full {
    height: 100%;
  }
  .h-screen {
    height: 100vh;
  }
  .max-h-52 {
    max-height: calc(var(--spacing) * 52);
  }
  .max-h-\\[150px\\] {
    max-height: 150px;
  }
  .max-h-\\[340px\\] {
    max-height: 340px;
  }
  .max-h-\\[618px\\] {
    max-height: 618px;
  }
  .max-h-\\[calc\\(100vh-200px\\)\\] {
    max-height: calc(100vh - 200px);
  }
  .min-h-8 {
    min-height: calc(var(--spacing) * 8);
  }
  .min-h-9 {
    min-height: calc(var(--spacing) * 9);
  }
  .min-h-10 {
    min-height: calc(var(--spacing) * 10);
  }
  .min-h-12 {
    min-height: calc(var(--spacing) * 12);
  }
  .min-h-15 {
    min-height: calc(var(--spacing) * 15);
  }
  .min-h-\\[24px\\] {
    min-height: 24px;
  }
  .min-h-\\[32px\\] {
    min-height: 32px;
  }
  .min-h-\\[50px\\] {
    min-height: 50px;
  }
  .min-h-\\[88px\\] {
    min-height: 88px;
  }
  .min-h-\\[120px\\] {
    min-height: 120px;
  }
  .min-h-\\[252px\\] {
    min-height: 252px;
  }
  .min-h-\\[466px\\] {
    min-height: 466px;
  }
  .w-1\\.5 {
    width: calc(var(--spacing) * 1.5);
  }
  .w-1\\/2 {
    width: calc(1/2 * 100%);
  }
  .w-2 {
    width: calc(var(--spacing) * 2);
  }
  .w-2\\/3 {
    width: calc(2/3 * 100%);
  }
  .w-3 {
    width: calc(var(--spacing) * 3);
  }
  .w-3\\/5 {
    width: calc(3/5 * 100%);
  }
  .w-4 {
    width: calc(var(--spacing) * 4);
  }
  .w-5 {
    width: calc(var(--spacing) * 5);
  }
  .w-6 {
    width: calc(var(--spacing) * 6);
  }
  .w-8 {
    width: calc(var(--spacing) * 8);
  }
  .w-9 {
    width: calc(var(--spacing) * 9);
  }
  .w-10 {
    width: calc(var(--spacing) * 10);
  }
  .w-40 {
    width: calc(var(--spacing) * 40);
  }
  .w-\\[11px\\] {
    width: 11px;
  }
  .w-\\[14px\\] {
    width: 14px;
  }
  .w-\\[18px\\] {
    width: 18px;
  }
  .w-\\[27\\%\\] {
    width: 27%;
  }
  .w-\\[29\\%\\] {
    width: 29%;
  }
  .w-\\[32px\\] {
    width: 32px;
  }
  .w-\\[38px\\] {
    width: 38px;
  }
  .w-\\[50\\%\\] {
    width: 50%;
  }
  .w-\\[70\\%\\] {
    width: 70%;
  }
  .w-\\[73\\%\\] {
    width: 73%;
  }
  .w-\\[130px\\] {
    width: 130px;
  }
  .w-\\[236px\\] {
    width: 236px;
  }
  .w-\\[264px\\] {
    width: 264px;
  }
  .w-\\[355px\\] {
    width: 355px;
  }
  .w-\\[375px\\] {
    width: 375px;
  }
  .w-\\[400px\\] {
    width: 400px;
  }
  .w-fit {
    width: fit-content;
  }
  .w-full {
    width: 100%;
  }
  .w-px {
    width: 1px;
  }
  .max-w-\\[190px\\] {
    max-width: 190px;
  }
  .max-w-\\[280px\\] {
    max-width: 280px;
  }
  .max-w-\\[300px\\] {
    max-width: 300px;
  }
  .max-w-\\[450px\\] {
    max-width: 450px;
  }
  .max-w-\\[486px\\] {
    max-width: 486px;
  }
  .min-w-8 {
    min-width: calc(var(--spacing) * 8);
  }
  .min-w-10 {
    min-width: calc(var(--spacing) * 10);
  }
  .min-w-12 {
    min-width: calc(var(--spacing) * 12);
  }
  .min-w-14 {
    min-width: calc(var(--spacing) * 14);
  }
  .min-w-22\\.5 {
    min-width: calc(var(--spacing) * 22.5);
  }
  .min-w-\\[1ch\\] {
    min-width: 1ch;
  }
  .min-w-\\[80px\\] {
    min-width: 80px;
  }
  .min-w-\\[154px\\] {
    min-width: 154px;
  }
  .min-w-\\[320px\\] {
    min-width: 320px;
  }
  .flex-1 {
    flex: 1;
  }
  .flex-auto {
    flex: auto;
  }
  .flex-shrink {
    flex-shrink: 1;
  }
  .shrink {
    flex-shrink: 1;
  }
  .shrink-0 {
    flex-shrink: 0;
  }
  .flex-grow {
    flex-grow: 1;
  }
  .grow-1 {
    flex-grow: 1;
  }
  .basis-1\\/2 {
    flex-basis: calc(1/2 * 100%);
  }
  .basis-\\[40\\%\\] {
    flex-basis: 40%;
  }
  .basis-\\[92px\\] {
    flex-basis: 92px;
  }
  .basis-\\[165px\\] {
    flex-basis: 165px;
  }
  .basis-auto {
    flex-basis: auto;
  }
  .basis-full {
    flex-basis: 100%;
  }
  .-translate-x-1\\/2 {
    --tw-translate-x: calc(calc(1/2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-x-\\[50\\%\\] {
    --tw-translate-x: calc(50% * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-0 {
    --tw-translate-x: calc(var(--spacing) * 0);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-\\[13px\\] {
    --tw-translate-x: 13px;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-y-1\\/2 {
    --tw-translate-y: calc(calc(1/2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-y-\\[2px\\] {
    --tw-translate-y: 2px;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .scale-150 {
    --tw-scale-x: 150%;
    --tw-scale-y: 150%;
    --tw-scale-z: 150%;
    scale: var(--tw-scale-x) var(--tw-scale-y);
  }
  .scale-\\[0\\.625\\] {
    scale: 0.625;
  }
  .-rotate-45 {
    rotate: calc(45deg * -1);
  }
  .rotate-0 {
    rotate: 0deg;
  }
  .rotate-90 {
    rotate: 90deg;
  }
  .rotate-180 {
    rotate: 180deg;
  }
  .rotate-\\[270deg\\] {
    rotate: 270deg;
  }
  .transform {
    transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
  }
  .transform-\\[translate\\(-50\\%\\)\\] {
    transform: translate(-50%);
  }
  .animate-spin {
    animation: var(--animate-spin);
  }
  .\\!cursor-default {
    cursor: default !important;
  }
  .\\!cursor-pointer {
    cursor: pointer !important;
  }
  .cursor-default {
    cursor: default;
  }
  .cursor-grab {
    cursor: grab;
  }
  .cursor-move {
    cursor: move;
  }
  .cursor-not-allowed {
    cursor: not-allowed;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .resize {
    resize: both;
  }
  .appearance-none {
    appearance: none;
  }
  .grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .grid-cols-\\[0_1fr\\] {
    grid-template-columns: 0 1fr;
  }
  .grid-cols-\\[365px_1fr\\] {
    grid-template-columns: 365px 1fr;
  }
  .grid-rows-\\[var\\(--layout-header-height\\)_auto\\] {
    grid-template-rows: var(--layout-header-height) auto;
  }
  .flex-col {
    flex-direction: column;
  }
  .flex-row {
    flex-direction: row;
  }
  .flex-nowrap {
    flex-wrap: nowrap;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .items-baseline {
    align-items: baseline;
  }
  .items-center {
    align-items: center;
  }
  .items-start {
    align-items: flex-start;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .justify-evenly {
    justify-content: space-evenly;
  }
  .justify-start {
    justify-content: flex-start;
  }
  .gap-0\\.5 {
    gap: calc(var(--spacing) * 0.5);
  }
  .gap-1 {
    gap: calc(var(--spacing) * 1);
  }
  .gap-1\\.5 {
    gap: calc(var(--spacing) * 1.5);
  }
  .gap-2 {
    gap: calc(var(--spacing) * 2);
  }
  .gap-2\\.5 {
    gap: calc(var(--spacing) * 2.5);
  }
  .gap-3 {
    gap: calc(var(--spacing) * 3);
  }
  .gap-3\\.5 {
    gap: calc(var(--spacing) * 3.5);
  }
  .gap-4 {
    gap: calc(var(--spacing) * 4);
  }
  .gap-5 {
    gap: calc(var(--spacing) * 5);
  }
  .gap-6 {
    gap: calc(var(--spacing) * 6);
  }
  .gap-\\[2px\\] {
    gap: 2px;
  }
  .gap-\\[6px\\] {
    gap: 6px;
  }
  .space-y-4 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .gap-x-0\\.5 {
    column-gap: calc(var(--spacing) * 0.5);
  }
  .gap-x-2 {
    column-gap: calc(var(--spacing) * 2);
  }
  .space-x-2 {
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 2) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-x-reverse)));
    }
  }
  .space-x-6 {
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 6) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-x-reverse)));
    }
  }
  .gap-y-1 {
    row-gap: calc(var(--spacing) * 1);
  }
  .gap-y-4 {
    row-gap: calc(var(--spacing) * 4);
  }
  .overflow-auto {
    overflow: auto;
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .overflow-x-hidden {
    overflow-x: hidden;
  }
  .overflow-y-auto {
    overflow-y: auto;
  }
  .scroll-smooth {
    scroll-behavior: smooth;
  }
  .rounded {
    border-radius: 0.25rem;
  }
  .rounded-2xl {
    border-radius: var(--radius-2xl);
  }
  .rounded-\\[2px\\] {
    border-radius: 2px;
  }
  .rounded-\\[6px\\] {
    border-radius: 6px;
  }
  .rounded-\\[10px\\] {
    border-radius: 10px;
  }
  .rounded-\\[20px\\] {
    border-radius: 20px;
  }
  .rounded-full {
    border-radius: calc(infinity * 1px);
  }
  .rounded-lg {
    border-radius: var(--radius-lg);
  }
  .rounded-md {
    border-radius: var(--radius-md);
  }
  .rounded-sm {
    border-radius: var(--radius-sm);
  }
  .rounded-xl {
    border-radius: var(--radius-xl);
  }
  .rounded-l-full {
    border-top-left-radius: calc(infinity * 1px);
    border-bottom-left-radius: calc(infinity * 1px);
  }
  .rounded-l-md {
    border-top-left-radius: var(--radius-md);
    border-bottom-left-radius: var(--radius-md);
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-2 {
    border-style: var(--tw-border-style);
    border-width: 2px;
  }
  .border-\\[0\\.5px\\] {
    border-style: var(--tw-border-style);
    border-width: 0.5px;
  }
  .border-\\[1px\\] {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-\\[10px\\] {
    border-style: var(--tw-border-style);
    border-width: 10px;
  }
  .border-t {
    border-top-style: var(--tw-border-style);
    border-top-width: 1px;
  }
  .border-t-\\[30px\\] {
    border-top-style: var(--tw-border-style);
    border-top-width: 30px;
  }
  .border-r {
    border-right-style: var(--tw-border-style);
    border-right-width: 1px;
  }
  .border-b {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  .border-b-2 {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 2px;
  }
  .border-b-\\[1px\\]\\! {
    border-bottom-style: var(--tw-border-style) !important;
    border-bottom-width: 1px !important;
  }
  .border-b-\\[50px\\] {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 50px;
  }
  .border-l {
    border-left-style: var(--tw-border-style);
    border-left-width: 1px;
  }
  .\\!border-solid {
    --tw-border-style: solid !important;
    border-style: solid !important;
  }
  .border-dashed {
    --tw-border-style: dashed;
    border-style: dashed;
  }
  .border-none {
    --tw-border-style: none;
    border-style: none;
  }
  .border-solid {
    --tw-border-style: solid;
    border-style: solid;
  }
  .border-solid\\! {
    --tw-border-style: solid !important;
    border-style: solid !important;
  }
  .border-\\[\\#23282d\\] {
    border-color: #23282d;
  }
  .border-bgPrimaryBase {
    border-color: var(--color-bgPrimaryBase);
  }
  .border-blue-500 {
    border-color: var(--color-blue-500);
  }
  .border-border200 {
    border-color: var(--color-border200);
  }
  .border-borderInteractive {
    border-color: var(--color-borderInteractive);
  }
  .border-btnSecondaryBorder {
    border-color: var(--color-btnSecondaryBorder);
  }
  .border-divider00 {
    border-color: var(--color-divider00);
  }
  .border-divider01 {
    border-color: var(--color-divider01);
  }
  .border-gray-100 {
    border-color: var(--color-gray-100);
  }
  .border-gray-150 {
    border-color: var(--color-gray-150);
  }
  .border-gray-200 {
    border-color: var(--color-gray-200);
  }
  .border-iconError {
    border-color: var(--color-iconError);
  }
  .border-inputBorder {
    border-color: var(--color-inputBorder);
  }
  .border-inputBorderDisabled {
    border-color: var(--color-inputBorderDisabled);
  }
  .border-inputBorderInteractive {
    border-color: var(--color-inputBorderInteractive);
  }
  .border-primary-500 {
    border-color: var(--color-primary-500);
  }
  .border-textSecondary\\/30 {
    border-color: color-mix(in srgb, #4A4C50 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-textSecondary) 30%, transparent);
    }
  }
  .border-transparent {
    border-color: transparent;
  }
  .border-t-transparent {
    border-top-color: transparent;
  }
  .\\!bg-bgPrimaryBase {
    background-color: var(--color-bgPrimaryBase) !important;
  }
  .\\!bg-bgSecondary {
    background-color: var(--color-bgSecondary) !important;
  }
  .\\!bg-bgSecondary\\/50 {
    background-color: color-mix(in srgb, #F2F2F3 50%, transparent) !important;
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-bgSecondary) 50%, transparent) !important;
    }
  }
  .bg-bgError {
    background-color: var(--color-bgError);
  }
  .bg-bgPrimaryBase {
    background-color: var(--color-bgPrimaryBase);
  }
  .bg-bgSecondary {
    background-color: var(--color-bgSecondary);
  }
  .bg-bgTertiary {
    background-color: var(--color-bgTertiary);
  }
  .bg-bgWarning {
    background-color: var(--color-bgWarning);
  }
  .bg-black\\/3 {
    background-color: color-mix(in srgb, #000000 3%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 3%, transparent);
    }
  }
  .bg-black\\/5 {
    background-color: color-mix(in srgb, #000000 5%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 5%, transparent);
    }
  }
  .bg-black\\/12 {
    background-color: color-mix(in srgb, #000000 12%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 12%, transparent);
    }
  }
  .bg-black\\/15 {
    background-color: color-mix(in srgb, #000000 15%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 15%, transparent);
    }
  }
  .bg-black\\/30 {
    background-color: color-mix(in srgb, #000000 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 30%, transparent);
    }
  }
  .bg-blue-500 {
    background-color: var(--color-blue-500);
  }
  .bg-brandPrimary {
    background-color: var(--color-brandPrimary);
  }
  .bg-brandSecondary {
    background-color: var(--color-brandSecondary);
  }
  .bg-btnGhostPrimaryPressed {
    background-color: var(--color-btnGhostPrimaryPressed);
  }
  .bg-btnPrimary {
    background-color: var(--color-btnPrimary);
  }
  .bg-btnPrimaryPressed {
    background-color: var(--color-btnPrimaryPressed);
  }
  .bg-btnSecondary {
    background-color: var(--color-btnSecondary);
  }
  .bg-btnSecondaryHover {
    background-color: var(--color-btnSecondaryHover);
  }
  .bg-btnSecondaryPressed {
    background-color: var(--color-btnSecondaryPressed);
  }
  .bg-btnTertiary {
    background-color: var(--color-btnTertiary);
  }
  .bg-btnTertiaryPressed {
    background-color: var(--color-btnTertiaryPressed);
  }
  .bg-divider00 {
    background-color: var(--color-divider00);
  }
  .bg-divider01 {
    background-color: var(--color-divider01);
  }
  .bg-divider03 {
    background-color: var(--color-divider03);
  }
  .bg-gray-50 {
    background-color: var(--color-gray-50);
  }
  .bg-gray-150 {
    background-color: var(--color-gray-150);
  }
  .bg-gray-300 {
    background-color: var(--color-gray-300);
  }
  .bg-gray-500 {
    background-color: var(--color-gray-500);
  }
  .bg-gray-800 {
    background-color: var(--color-gray-800);
  }
  .bg-iconError {
    background-color: var(--color-iconError);
  }
  .bg-iconPrimary {
    background-color: var(--color-iconPrimary);
  }
  .bg-iconTertiary {
    background-color: var(--color-iconTertiary);
  }
  .bg-inputBasePrimary {
    background-color: var(--color-inputBasePrimary);
  }
  .bg-primary-100 {
    background-color: var(--color-primary-100);
  }
  .bg-primary-500 {
    background-color: var(--color-primary-500);
  }
  .bg-primary-600 {
    background-color: var(--color-primary-600);
  }
  .bg-tagSoftGrayBg {
    background-color: var(--color-tagSoftGrayBg);
  }
  .bg-tagSoftPrimaryBg {
    background-color: var(--color-tagSoftPrimaryBg);
  }
  .bg-transparent {
    background-color: transparent;
  }
  .bg-white {
    background-color: var(--color-white);
  }
  .bg-white\\/5 {
    background-color: color-mix(in srgb, #FFFFFF 5%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 5%, transparent);
    }
  }
  .bg-gradient-to-r {
    --tw-gradient-position: to right in oklab;
    background-image: linear-gradient(var(--tw-gradient-stops));
  }
  .bg-\\[url\\(\\'\\.\\.\\/src\\/assets\\/images\\/checkers\\.png\\'\\)\\] {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  .from-0\\% {
    --tw-gradient-from-position: 0%;
  }
  .to-100\\% {
    --tw-gradient-to-position: 100%;
  }
  .bg-contain {
    background-size: contain;
  }
  .bg-cover {
    background-size: cover;
  }
  .bg-center {
    background-position: center;
  }
  .fill-iconSecondary {
    fill: var(--color-iconSecondary);
  }
  .fill-textPrimary {
    fill: var(--color-textPrimary);
  }
  .stroke-btnPrimary {
    stroke: var(--color-btnPrimary);
  }
  .stroke-current {
    stroke: currentcolor;
  }
  .stroke-iconOnColor {
    stroke: var(--color-iconOnColor);
  }
  .stroke-iconPrimary {
    stroke: var(--color-iconPrimary);
  }
  .object-cover {
    object-fit: cover;
  }
  .p-0 {
    padding: calc(var(--spacing) * 0);
  }
  .p-0\\.5 {
    padding: calc(var(--spacing) * 0.5);
  }
  .p-1 {
    padding: calc(var(--spacing) * 1);
  }
  .p-1\\.5 {
    padding: calc(var(--spacing) * 1.5);
  }
  .p-2 {
    padding: calc(var(--spacing) * 2);
  }
  .p-2\\.5 {
    padding: calc(var(--spacing) * 2.5);
  }
  .p-3 {
    padding: calc(var(--spacing) * 3);
  }
  .p-4 {
    padding: calc(var(--spacing) * 4);
  }
  .p-6 {
    padding: calc(var(--spacing) * 6);
  }
  .p-\\[var\\(--sidebar-padding\\)\\] {
    padding: var(--sidebar-padding);
  }
  .px-0\\.5 {
    padding-inline: calc(var(--spacing) * 0.5);
  }
  .px-1 {
    padding-inline: calc(var(--spacing) * 1);
  }
  .px-1\\.5 {
    padding-inline: calc(var(--spacing) * 1.5);
  }
  .px-2 {
    padding-inline: calc(var(--spacing) * 2);
  }
  .px-2\\.5 {
    padding-inline: calc(var(--spacing) * 2.5);
  }
  .px-3 {
    padding-inline: calc(var(--spacing) * 3);
  }
  .px-3\\.5 {
    padding-inline: calc(var(--spacing) * 3.5);
  }
  .px-4 {
    padding-inline: calc(var(--spacing) * 4);
  }
  .px-4\\.5 {
    padding-inline: calc(var(--spacing) * 4.5);
  }
  .px-6 {
    padding-inline: calc(var(--spacing) * 6);
  }
  .px-7 {
    padding-inline: calc(var(--spacing) * 7);
  }
  .px-8 {
    padding-inline: calc(var(--spacing) * 8);
  }
  .px-10 {
    padding-inline: calc(var(--spacing) * 10);
  }
  .px-12 {
    padding-inline: calc(var(--spacing) * 12);
  }
  .py-0\\.5 {
    padding-block: calc(var(--spacing) * 0.5);
  }
  .py-1 {
    padding-block: calc(var(--spacing) * 1);
  }
  .py-1\\.5 {
    padding-block: calc(var(--spacing) * 1.5);
  }
  .py-2 {
    padding-block: calc(var(--spacing) * 2);
  }
  .py-2\\.5 {
    padding-block: calc(var(--spacing) * 2.5);
  }
  .py-2\\.75 {
    padding-block: calc(var(--spacing) * 2.75);
  }
  .py-3 {
    padding-block: calc(var(--spacing) * 3);
  }
  .py-4 {
    padding-block: calc(var(--spacing) * 4);
  }
  .py-4\\.5 {
    padding-block: calc(var(--spacing) * 4.5);
  }
  .py-6 {
    padding-block: calc(var(--spacing) * 6);
  }
  .py-8 {
    padding-block: calc(var(--spacing) * 8);
  }
  .pt-0 {
    padding-top: calc(var(--spacing) * 0);
  }
  .pt-1\\.5 {
    padding-top: calc(var(--spacing) * 1.5);
  }
  .pt-2 {
    padding-top: calc(var(--spacing) * 2);
  }
  .pt-2\\.5 {
    padding-top: calc(var(--spacing) * 2.5);
  }
  .pt-3 {
    padding-top: calc(var(--spacing) * 3);
  }
  .pt-5 {
    padding-top: calc(var(--spacing) * 5);
  }
  .pr-3 {
    padding-right: calc(var(--spacing) * 3);
  }
  .pr-6 {
    padding-right: calc(var(--spacing) * 6);
  }
  .pb-2 {
    padding-bottom: calc(var(--spacing) * 2);
  }
  .pb-2\\.5 {
    padding-bottom: calc(var(--spacing) * 2.5);
  }
  .pb-3 {
    padding-bottom: calc(var(--spacing) * 3);
  }
  .pb-4 {
    padding-bottom: calc(var(--spacing) * 4);
  }
  .pb-5 {
    padding-bottom: calc(var(--spacing) * 5);
  }
  .pb-6 {
    padding-bottom: calc(var(--spacing) * 6);
  }
  .pb-8 {
    padding-bottom: calc(var(--spacing) * 8);
  }
  .pl-3 {
    padding-left: calc(var(--spacing) * 3);
  }
  .pl-3\\.5 {
    padding-left: calc(var(--spacing) * 3.5);
  }
  .pl-5 {
    padding-left: calc(var(--spacing) * 5);
  }
  .pl-8 {
    padding-left: calc(var(--spacing) * 8);
  }
  .text-center {
    text-align: center;
  }
  .text-left {
    text-align: left;
  }
  .indent-1 {
    text-indent: calc(var(--spacing) * 1);
  }
  .text-base {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
  }
  .text-lg {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-xs {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .text-\\[15px\\] {
    font-size: 15px;
  }
  .\\!leading-\\[inherit\\] {
    --tw-leading: inherit !important;
    line-height: inherit !important;
  }
  .leading-4 {
    --tw-leading: calc(var(--spacing) * 4);
    line-height: calc(var(--spacing) * 4);
  }
  .leading-5\\! {
    --tw-leading: calc(var(--spacing) * 5) !important;
    line-height: calc(var(--spacing) * 5) !important;
  }
  .leading-6\\! {
    --tw-leading: calc(var(--spacing) * 6) !important;
    line-height: calc(var(--spacing) * 6) !important;
  }
  .leading-7 {
    --tw-leading: calc(var(--spacing) * 7);
    line-height: calc(var(--spacing) * 7);
  }
  .leading-10 {
    --tw-leading: calc(var(--spacing) * 10);
    line-height: calc(var(--spacing) * 10);
  }
  .leading-\\[16px\\] {
    --tw-leading: 16px;
    line-height: 16px;
  }
  .font-bold {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .wrap-anywhere {
    overflow-wrap: anywhere;
  }
  .\\[word-break\\:break-word\\] {
    word-break: break-word;
  }
  .break-all {
    word-break: break-all;
  }
  .text-ellipsis {
    text-overflow: ellipsis;
  }
  .whitespace-nowrap {
    white-space: nowrap;
  }
  .text-bgSecondary {
    color: var(--color-bgSecondary);
  }
  .text-bgTertiary {
    color: var(--color-bgTertiary);
  }
  .text-brandTextPrimary {
    color: var(--color-brandTextPrimary);
  }
  .text-btnPrimary {
    color: var(--color-btnPrimary);
  }
  .text-error-500 {
    color: var(--color-error-500);
  }
  .text-gray-700 {
    color: var(--color-gray-700);
  }
  .text-iconError {
    color: var(--color-iconError);
  }
  .text-iconSecondary {
    color: var(--color-iconSecondary);
  }
  .text-iconSuccess {
    color: var(--color-iconSuccess);
  }
  .text-iconTertiary {
    color: var(--color-iconTertiary);
  }
  .text-inherit {
    color: inherit;
  }
  .text-primary-500 {
    color: var(--color-primary-500);
  }
  .text-primary-700 {
    color: var(--color-primary-700);
  }
  .text-red-500 {
    color: var(--color-red-500);
  }
  .text-red-600 {
    color: var(--color-red-600);
  }
  .text-tagSoftGrayText {
    color: var(--color-tagSoftGrayText);
  }
  .text-tagSoftPrimaryText {
    color: var(--color-tagSoftPrimaryText);
  }
  .text-textDisabled {
    color: var(--color-textDisabled);
  }
  .text-textError {
    color: var(--color-textError);
  }
  .text-textLink {
    color: var(--color-textLink);
  }
  .text-textLinkPressed {
    color: var(--color-textLinkPressed);
  }
  .text-textOnColor {
    color: var(--color-textOnColor);
  }
  .text-textPrimary {
    color: var(--color-textPrimary);
  }
  .text-textSecondary {
    color: var(--color-textSecondary);
  }
  .text-textTertiary {
    color: var(--color-textTertiary);
  }
  .text-transparent {
    color: transparent;
  }
  .text-white {
    color: var(--color-white);
  }
  .lowercase {
    text-transform: lowercase;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .italic {
    font-style: italic;
  }
  .not-italic {
    font-style: normal;
  }
  .underline {
    text-decoration-line: underline;
  }
  .antialiased {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .accent-\\[\\#ccc\\] {
    accent-color: #ccc;
  }
  .accent-primary-500 {
    accent-color: var(--color-primary-500);
  }
  .opacity-0 {
    opacity: 0%;
  }
  .opacity-10 {
    opacity: 10%;
  }
  .opacity-50 {
    opacity: 50%;
  }
  .opacity-100 {
    opacity: 100%;
  }
  .shadow {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_2px_2px_0_rgba\\(46\\,81\\,98\\,0\\,18\\)\\] {
    --tw-shadow: 0 2px 2px 0 var(--tw-shadow-color, rgba(46,81,98,0,18));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_10px_40px_10px_rgba\\(0\\,0\\,0\\,0\\.08\\)\\] {
    --tw-shadow: 0px 10px 40px 10px var(--tw-shadow-color, rgba(0,0,0,0.08));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-md {
    --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .outline {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
  .outline-4 {
    outline-style: var(--tw-outline-style);
    outline-width: 4px;
  }
  .outline-borderInteractive\\/20 {
    outline-color: color-mix(in srgb, #00A0FF 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      outline-color: color-mix(in oklab, var(--color-borderInteractive) 20%, transparent);
    }
  }
  .outline-inputBorderInteractive {
    outline-color: var(--color-inputBorderInteractive);
  }
  .blur {
    --tw-blur: blur(8px);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .filter {
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .backdrop-blur-lg {
    --tw-backdrop-blur: blur(var(--blur-lg));
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .transition {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter, display, visibility, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[all_0\\.3s_cubic-bezier\\(0\\,0\\,0\\.8\\,1\\)\\] {
    transition-property: all 0.3s cubic-bezier(0,0,0.8,1);
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[min-height\\] {
    transition-property: min-height;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[opacity_0\\.25s_ease-in\\] {
    transition-property: opacity 0.25s ease-in;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-all {
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-colors {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-opacity {
    transition-property: opacity;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-transform {
    transition-property: transform, translate, scale, rotate;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .duration-100 {
    --tw-duration: 100ms;
    transition-duration: 100ms;
  }
  .duration-150 {
    --tw-duration: 150ms;
    transition-duration: 150ms;
  }
  .duration-200 {
    --tw-duration: 200ms;
    transition-duration: 200ms;
  }
  .duration-300 {
    --tw-duration: 300ms;
    transition-duration: 300ms;
  }
  .ease-in {
    --tw-ease: var(--ease-in);
    transition-timing-function: var(--ease-in);
  }
  .ease-in-out {
    --tw-ease: var(--ease-in-out);
    transition-timing-function: var(--ease-in-out);
  }
  .outline-none {
    --tw-outline-style: none;
    outline-style: none;
  }
  .outline-solid {
    --tw-outline-style: solid;
    outline-style: solid;
  }
  .select-none {
    -webkit-user-select: none;
    user-select: none;
  }
  .\\[-moz-appearance\\:textfield\\] {
    -moz-appearance: textfield;
  }
  .\\[program\\:consumer-website-render\\] {
    program: consumer-website-render;
  }
  .\\[program\\:editor\\] {
    program: editor;
  }
  .\\[program\\:nest\\] {
    program: nest;
  }
  .\\[program\\:nginx\\] {
    program: nginx;
  }
  .\\[program\\:node\\] {
    program: node;
  }
  .\\[program\\:publisher\\] {
    program: publisher;
  }
  .group-hover\\:border-primary-500 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        border-color: var(--color-primary-500);
      }
    }
  }
  .group-hover\\:stroke-btnPrimaryHover {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        stroke: var(--color-btnPrimaryHover);
      }
    }
  }
  .group-hover\\:text-iconSecondary {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        color: var(--color-iconSecondary);
      }
    }
  }
  .group-hover\\:text-textSecondary {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        color: var(--color-textSecondary);
      }
    }
  }
  .after\\:grow-0 {
    &::after {
      content: var(--tw-content);
      flex-grow: 0;
    }
  }
  .after\\:content-\\[\\'\\'\\] {
    &::after {
      content: var(--tw-content);
      --tw-content: '';
      content: var(--tw-content);
    }
  }
  .last\\:border-0 {
    &:last-child {
      border-style: var(--tw-border-style);
      border-width: 0px;
    }
  }
  .last-of-type\\:mb-5 {
    &:last-of-type {
      margin-bottom: calc(var(--spacing) * 5);
    }
  }
  .last-of-type\\:mb-8 {
    &:last-of-type {
      margin-bottom: calc(var(--spacing) * 8);
    }
  }
  .checked\\:border-primary-500 {
    &:checked {
      border-color: var(--color-primary-500);
    }
  }
  .checked\\:bg-primary-500 {
    &:checked {
      background-color: var(--color-primary-500);
    }
  }
  .checked\\:bg-transparent {
    &:checked {
      background-color: transparent;
    }
  }
  .group-hover\\:checked\\:border-primary-600 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        &:checked {
          border-color: var(--color-primary-600);
        }
      }
    }
  }
  .group-hover\\:checked\\:bg-primary-600 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        &:checked {
          background-color: var(--color-primary-600);
        }
      }
    }
  }
  .hover\\:border-blue-500 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-blue-500);
      }
    }
  }
  .hover\\:border-blue-600 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-blue-600);
      }
    }
  }
  .hover\\:border-borderInteractive {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-borderInteractive);
      }
    }
  }
  .hover\\:border-inputBorderHover {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-inputBorderHover);
      }
    }
  }
  .hover\\:\\!bg-bgPrimaryBase {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-bgPrimaryBase) !important;
      }
    }
  }
  .hover\\:\\!bg-bgSecondary {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-bgSecondary) !important;
      }
    }
  }
  .hover\\:bg-bgSecondary {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-bgSecondary);
      }
    }
  }
  .hover\\:bg-black\\/3 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, #000000 3%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-black) 3%, transparent);
        }
      }
    }
  }
  .hover\\:bg-blue-600 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-blue-600);
      }
    }
  }
  .hover\\:bg-brandPrimaryHover {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-brandPrimaryHover);
      }
    }
  }
  .hover\\:bg-brandSecondaryHover {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-brandSecondaryHover);
      }
    }
  }
  .hover\\:bg-btnGhostPrimaryHover {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-btnGhostPrimaryHover);
      }
    }
  }
  .hover\\:bg-btnPrimaryHover {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-btnPrimaryHover);
      }
    }
  }
  .hover\\:bg-btnSecondaryHover {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-btnSecondaryHover);
      }
    }
  }
  .hover\\:bg-btnTertiaryHover {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-btnTertiaryHover);
      }
    }
  }
  .hover\\:bg-gray-50 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-50);
      }
    }
  }
  .hover\\:bg-gray-100 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-100);
      }
    }
  }
  .hover\\:bg-gray-150 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-150);
      }
    }
  }
  .hover\\:bg-primary-500 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-primary-500);
      }
    }
  }
  .hover\\:fill-iconPrimary {
    &:hover {
      @media (hover: hover) {
        fill: var(--color-iconPrimary);
      }
    }
  }
  .hover\\:text-bgSecondary {
    &:hover {
      @media (hover: hover) {
        color: var(--color-bgSecondary);
      }
    }
  }
  .hover\\:text-bgTertiary {
    &:hover {
      @media (hover: hover) {
        color: var(--color-bgTertiary);
      }
    }
  }
  .hover\\:text-brandTextPrimary {
    &:hover {
      @media (hover: hover) {
        color: var(--color-brandTextPrimary);
      }
    }
  }
  .hover\\:text-gray-150 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-gray-150);
      }
    }
  }
  .hover\\:text-iconError {
    &:hover {
      @media (hover: hover) {
        color: var(--color-iconError);
      }
    }
  }
  .hover\\:text-primary-600 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-primary-600);
      }
    }
  }
  .hover\\:text-textLinkHover {
    &:hover {
      @media (hover: hover) {
        color: var(--color-textLinkHover);
      }
    }
  }
  .hover\\:text-textPrimary {
    &:hover {
      @media (hover: hover) {
        color: var(--color-textPrimary);
      }
    }
  }
  .hover\\:text-textSecondary {
    &:hover {
      @media (hover: hover) {
        color: var(--color-textSecondary);
      }
    }
  }
  .hover\\:underline {
    &:hover {
      @media (hover: hover) {
        text-decoration-line: underline;
      }
    }
  }
  .hover\\:outline-solid {
    &:hover {
      @media (hover: hover) {
        --tw-outline-style: solid;
        outline-style: solid;
      }
    }
  }
  .focus\\:border-none {
    &:focus {
      --tw-border-style: none;
      border-style: none;
    }
  }
  .focus\\:outline-4 {
    &:focus {
      outline-style: var(--tw-outline-style);
      outline-width: 4px;
    }
  }
  .focus\\:outline-none {
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .active\\:bg-bgSecondary {
    &:active {
      background-color: var(--color-bgSecondary);
    }
  }
  .active\\:bg-brandPrimaryPressed {
    &:active {
      background-color: var(--color-brandPrimaryPressed);
    }
  }
  .active\\:bg-brandSecondaryPressed {
    &:active {
      background-color: var(--color-brandSecondaryPressed);
    }
  }
  .active\\:bg-btnGhostPrimaryPressed {
    &:active {
      background-color: var(--color-btnGhostPrimaryPressed);
    }
  }
  .active\\:bg-btnPrimaryPressed {
    &:active {
      background-color: var(--color-btnPrimaryPressed);
    }
  }
  .active\\:bg-btnSecondaryPressed {
    &:active {
      background-color: var(--color-btnSecondaryPressed);
    }
  }
  .active\\:bg-btnTertiaryPressed {
    &:active {
      background-color: var(--color-btnTertiaryPressed);
    }
  }
  .active\\:bg-gray-150 {
    &:active {
      background-color: var(--color-gray-150);
    }
  }
  .active\\:text-textPrimary {
    &:active {
      color: var(--color-textPrimary);
    }
  }
  .disabled\\:cursor-default {
    &:disabled {
      cursor: default;
    }
  }
  .disabled\\:border-bgTertiary {
    &:disabled {
      border-color: var(--color-bgTertiary);
    }
  }
  .disabled\\:border-borderDisabled {
    &:disabled {
      border-color: var(--color-borderDisabled);
    }
  }
  .disabled\\:bg-btnDisabled {
    &:disabled {
      background-color: var(--color-btnDisabled);
    }
  }
  .disabled\\:bg-gray-200 {
    &:disabled {
      background-color: var(--color-gray-200);
    }
  }
  .disabled\\:text-iconDisabled {
    &:disabled {
      color: var(--color-iconDisabled);
    }
  }
  .disabled\\:text-textDisabled {
    &:disabled {
      color: var(--color-textDisabled);
    }
  }
  .disabled\\:group-hover\\:border-bgTertiary {
    &:disabled {
      &:is(:where(.group):hover *) {
        @media (hover: hover) {
          border-color: var(--color-bgTertiary);
        }
      }
    }
  }
  .disabled\\:checked\\:border-bgTertiary {
    &:disabled {
      &:checked {
        border-color: var(--color-bgTertiary);
      }
    }
  }
  .disabled\\:checked\\:bg-bgTertiary {
    &:disabled {
      &:checked {
        background-color: var(--color-bgTertiary);
      }
    }
  }
  .disabled\\:hover\\:bg-btnDisabled {
    &:disabled {
      &:hover {
        @media (hover: hover) {
          background-color: var(--color-btnDisabled);
        }
      }
    }
  }
  .disabled\\:hover\\:bg-btnSecondary {
    &:disabled {
      &:hover {
        @media (hover: hover) {
          background-color: var(--color-btnSecondary);
        }
      }
    }
  }
  .disabled\\:hover\\:bg-transparent {
    &:disabled {
      &:hover {
        @media (hover: hover) {
          background-color: transparent;
        }
      }
    }
  }
  .disabled\\:hover\\:text-iconTertiary {
    &:disabled {
      &:hover {
        @media (hover: hover) {
          color: var(--color-iconTertiary);
        }
      }
    }
  }
  .disabled\\:hover\\:text-textDisabled {
    &:disabled {
      &:hover {
        @media (hover: hover) {
          color: var(--color-textDisabled);
        }
      }
    }
  }
  .disabled\\:checked\\:hover\\:border-bgTertiary {
    &:disabled {
      &:checked {
        &:hover {
          @media (hover: hover) {
            border-color: var(--color-bgTertiary);
          }
        }
      }
    }
  }
  .disabled\\:checked\\:hover\\:bg-bgTertiary {
    &:disabled {
      &:checked {
        &:hover {
          @media (hover: hover) {
            background-color: var(--color-bgTertiary);
          }
        }
      }
    }
  }
  .\\[\\&\\:\\:-webkit-inner-spin-button\\]\\:appearance-none {
    &::-webkit-inner-spin-button {
      appearance: none;
    }
  }
  .\\[\\&\\:\\:-webkit-outer-spin-button\\]\\:appearance-none {
    &::-webkit-outer-spin-button {
      appearance: none;
    }
  }
  .\\[\\&\\:\\:-webkit-search-cancel-button\\]\\:cursor-pointer {
    &::-webkit-search-cancel-button {
      cursor: pointer;
    }
  }
  .\\[\\&\\:\\:-webkit-slider-thumb\\]\\:h-5 {
    &::-webkit-slider-thumb {
      height: calc(var(--spacing) * 5);
    }
  }
  .\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-5 {
    &::-webkit-slider-thumb {
      width: calc(var(--spacing) * 5);
    }
  }
  .\\[\\&\\:\\:-webkit-slider-thumb\\]\\:appearance-none {
    &::-webkit-slider-thumb {
      appearance: none;
    }
  }
  .\\[\\&\\:\\:-webkit-slider-thumb\\]\\:rounded-full {
    &::-webkit-slider-thumb {
      border-radius: calc(infinity * 1px);
    }
  }
  .\\[\\&\\:\\:-webkit-slider-thumb\\]\\:border-2 {
    &::-webkit-slider-thumb {
      border-style: var(--tw-border-style);
      border-width: 2px;
    }
  }
  .\\[\\&\\:\\:-webkit-slider-thumb\\]\\:border-\\[\\#ccc\\] {
    &::-webkit-slider-thumb {
      border-color: #ccc;
    }
  }
  .\\[\\&\\:\\:-webkit-slider-thumb\\]\\:border-primary-500 {
    &::-webkit-slider-thumb {
      border-color: var(--color-primary-500);
    }
  }
  .\\[\\&\\:\\:-webkit-slider-thumb\\]\\:bg-white {
    &::-webkit-slider-thumb {
      background-color: var(--color-white);
    }
  }
  .\\[\\&\\:\\:-webkit-slider-thumb\\]\\:shadow {
    &::-webkit-slider-thumb {
      --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .\\[\\&\\:\\:-webkit-slider-thumb\\]\\:transition-all {
    &::-webkit-slider-thumb {
      transition-property: all;
      transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
      transition-duration: var(--tw-duration, var(--default-transition-duration));
    }
  }
  .hover\\:\\[\\&\\:\\:-webkit-slider-thumb\\]\\:bg-btnSecondaryHover {
    &:hover {
      @media (hover: hover) {
        &::-webkit-slider-thumb {
          background-color: var(--color-btnSecondaryHover);
        }
      }
    }
  }
  .active\\:\\[\\&\\:\\:-webkit-slider-thumb\\]\\:bg-btnSecondaryPressed {
    &:active {
      &::-webkit-slider-thumb {
        background-color: var(--color-btnSecondaryPressed);
      }
    }
  }
  .\\[\\&\\:first-of-type\\]\\:mt-2\\.5 {
    &:first-of-type {
      margin-top: calc(var(--spacing) * 2.5);
    }
  }
  .\\[\\&\\:has\\(span\\>svg\\:hover\\)\\]\\:hover\\:bg-none {
    &:has(span>svg:hover) {
      &:hover {
        @media (hover: hover) {
          background-image: none;
        }
      }
    }
  }
  .\\[\\&\\:hover\\>span\\>svg\\]\\:opacity-100 {
    &:hover>span>svg {
      opacity: 100%;
    }
  }
  .\\[\\&\\:not\\(\\:last-of-type\\)\\]\\:border-b {
    &:not(:last-of-type) {
      border-bottom-style: var(--tw-border-style);
      border-bottom-width: 1px;
    }
  }
  .\\[\\&\\>\\*\\]\\:\\!m-0 {
    &>* {
      margin: calc(var(--spacing) * 0) !important;
    }
  }
  .\\[\\&\\>\\*\\:nth-child\\(1\\)\\]\\:col-span-2 {
    &>*:nth-child(1) {
      grid-column: span 2 / span 2;
    }
  }
  .\\[\\&\\>\\*\\:nth-child\\(2\\)\\]\\:col-span-2 {
    &>*:nth-child(2) {
      grid-column: span 2 / span 2;
    }
  }
  .\\[\\&\\>\\.rw-input\\]\\:h-10\\! {
    &>.rw-input {
      height: calc(var(--spacing) * 10) !important;
    }
  }
  .\\[\\&\\>a\\]\\:text-textLink {
    &>a {
      color: var(--color-textLink);
    }
  }
  .\\[\\&\\>a\\]\\:hover\\:text-textLinkHover {
    &>a {
      &:hover {
        @media (hover: hover) {
          color: var(--color-textLinkHover);
        }
      }
    }
  }
  .\\[\\&\\>a\\]\\:focus\\:text-textLinkPressed {
    &>a {
      &:focus {
        color: var(--color-textLinkPressed);
      }
    }
  }
  .\\[\\&\\>div\\]\\:basis-full {
    &>div {
      flex-basis: 100%;
    }
  }
  .\\[\\&\\>div\\>svg\\]\\:stroke-iconError {
    &>div>svg {
      stroke: var(--color-iconError);
    }
  }
  .\\[\\&\\>div\\>svg\\]\\:stroke-iconPrimary {
    &>div>svg {
      stroke: var(--color-iconPrimary);
    }
  }
  .\\[\\&\\>img\\]\\:max-h-\\[300px\\] {
    &>img {
      max-height: 300px;
    }
  }
  .\\[\\&\\>img\\]\\:max-h-full {
    &>img {
      max-height: 100%;
    }
  }
  .\\[\\&\\>img\\]\\:max-w-\\[150px\\] {
    &>img {
      max-width: 150px;
    }
  }
  .\\[\\&\\>img\\]\\:max-w-full {
    &>img {
      max-width: 100%;
    }
  }
  .\\[\\&\\>path\\]\\:fill-iconPrimary {
    &>path {
      fill: var(--color-iconPrimary);
    }
  }
  .\\[\\&\\>path\\]\\:fill-iconSecondary {
    &>path {
      fill: var(--color-iconSecondary);
    }
  }
  .\\[\\&\\>path\\]\\:stroke-iconDisabled {
    &>path {
      stroke: var(--color-iconDisabled);
    }
  }
  .\\[\\&\\>path\\]\\:stroke-iconSecondary\\! {
    &>path {
      stroke: var(--color-iconSecondary) !important;
    }
  }
  .\\[\\&\\>path\\]\\:stroke-iconTertiary {
    &>path {
      stroke: var(--color-iconTertiary);
    }
  }
  .\\[\\&\\>path\\]\\:stroke-none\\! {
    &>path {
      stroke: none !important;
    }
  }
  .\\[\\&\\>path\\:first-child\\]\\:fill-gray-150 {
    &>path:first-child {
      fill: var(--color-gray-150);
    }
  }
  .\\[\\&\\>path\\:first-child\\]\\:fill-primary-200 {
    &>path:first-child {
      fill: var(--color-primary-200);
    }
  }
  .\\[\\&\\>path\\:last-child\\]\\:fill-iconSecondary {
    &>path:last-child {
      fill: var(--color-iconSecondary);
    }
  }
  .\\[\\&\\>path\\:last-child\\]\\:fill-tagSoftPrimaryIcon {
    &>path:last-child {
      fill: var(--color-tagSoftPrimaryIcon);
    }
  }
  .\\[\\&\\>span\\]\\:border-iconSecondary {
    &>span {
      border-color: var(--color-iconSecondary);
    }
  }
  .\\[\\&\\>span\\]\\:border-primary-500 {
    &>span {
      border-color: var(--color-primary-500);
    }
  }
  .\\[\\&\\>span\\]\\:border-primary-700 {
    &>span {
      border-color: var(--color-primary-700);
    }
  }
  .\\[\\&\\>span\\]\\:border-textLink {
    &>span {
      border-color: var(--color-textLink);
    }
  }
  .\\[\\&\\>span\\]\\:border-textLinkPressed {
    &>span {
      border-color: var(--color-textLinkPressed);
    }
  }
  .\\[\\&\\>span\\]\\:border-textOnColor {
    &>span {
      border-color: var(--color-textOnColor);
    }
  }
  .\\[\\&\\>span\\]\\:\\!border-t-transparent {
    &>span {
      border-top-color: transparent !important;
    }
  }
  .\\[\\&\\>span\\]\\:text-textPrimary {
    &>span {
      color: var(--color-textPrimary);
    }
  }
  .hover\\:\\[\\&\\>span\\]\\:border-primary-600 {
    &:hover {
      @media (hover: hover) {
        &>span {
          border-color: var(--color-primary-600);
        }
      }
    }
  }
  .hover\\:\\[\\&\\>span\\]\\:border-textLinkHover {
    &:hover {
      @media (hover: hover) {
        &>span {
          border-color: var(--color-textLinkHover);
        }
      }
    }
  }
  .hover\\:\\[\\&\\>span\\]\\:border-t-transparent {
    &:hover {
      @media (hover: hover) {
        &>span {
          border-top-color: transparent;
        }
      }
    }
  }
  .hover\\:\\[\\&\\>span\\]\\:text-textSecondary {
    &:hover {
      @media (hover: hover) {
        &>span {
          color: var(--color-textSecondary);
        }
      }
    }
  }
  .active\\:\\[\\&\\>span\\]\\:border-primary-700 {
    &:active {
      &>span {
        border-color: var(--color-primary-700);
      }
    }
  }
  .active\\:\\[\\&\\>span\\]\\:border-textLinkPressed {
    &:active {
      &>span {
        border-color: var(--color-textLinkPressed);
      }
    }
  }
  .active\\:\\[\\&\\>span\\]\\:text-textPrimary {
    &:active {
      &>span {
        color: var(--color-textPrimary);
      }
    }
  }
  .disabled\\:\\[\\&\\>span\\]\\:border-iconDisabled {
    &:disabled {
      &>span {
        border-color: var(--color-iconDisabled);
      }
    }
  }
  .disabled\\:\\[\\&\\>span\\]\\:border-textDisabled {
    &:disabled {
      &>span {
        border-color: var(--color-textDisabled);
      }
    }
  }
  .disabled\\:\\[\\&\\>span\\]\\:border-t-transparent {
    &:disabled {
      &>span {
        border-top-color: transparent;
      }
    }
  }
  .\\[\\&\\>svg\\]\\:h-3 {
    &>svg {
      height: calc(var(--spacing) * 3);
    }
  }
  .\\[\\&\\>svg\\]\\:h-5 {
    &>svg {
      height: calc(var(--spacing) * 5);
    }
  }
  .\\[\\&\\>svg\\]\\:h-10 {
    &>svg {
      height: calc(var(--spacing) * 10);
    }
  }
  .\\[\\&\\>svg\\]\\:h-\\[11px\\] {
    &>svg {
      height: 11px;
    }
  }
  .\\[\\&\\>svg\\]\\:w-3 {
    &>svg {
      width: calc(var(--spacing) * 3);
    }
  }
  .\\[\\&\\>svg\\]\\:w-5 {
    &>svg {
      width: calc(var(--spacing) * 5);
    }
  }
  .\\[\\&\\>svg\\]\\:w-10 {
    &>svg {
      width: calc(var(--spacing) * 10);
    }
  }
  .\\[\\&\\>svg\\]\\:w-\\[11px\\] {
    &>svg {
      width: 11px;
    }
  }
  .\\[\\&\\>svg\\]\\:shrink-0 {
    &>svg {
      flex-shrink: 0;
    }
  }
  .\\[\\&\\>svg\\]\\:fill-iconSecondary {
    &>svg {
      fill: var(--color-iconSecondary);
    }
  }
  .\\[\\&\\>svg\\]\\:transition-colors {
    &>svg {
      transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
      transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
      transition-duration: var(--tw-duration, var(--default-transition-duration));
    }
  }
  .\\[\\&\\>svg\\]\\:group-hover\\:fill-iconPrimary {
    &>svg {
      &:is(:where(.group):hover *) {
        @media (hover: hover) {
          fill: var(--color-iconPrimary);
        }
      }
    }
  }
  .hover\\:\\[\\&\\>svg\\]\\:fill-iconSecondary {
    &:hover {
      @media (hover: hover) {
        &>svg {
          fill: var(--color-iconSecondary);
        }
      }
    }
  }
  .\\[\\&\\>svg\\>path\\]\\:fill-iconSecondary {
    &>svg>path {
      fill: var(--color-iconSecondary);
    }
  }
  .\\[\\&\\>svg\\>path\\]\\:stroke-iconSecondary {
    &>svg>path {
      stroke: var(--color-iconSecondary);
    }
  }
  .\\[\\&\\>svg\\>path\\]\\:stroke-iconTertiary {
    &>svg>path {
      stroke: var(--color-iconTertiary);
    }
  }
  .\\[\\&\\>svg\\>path\\]\\:stroke-none {
    &>svg>path {
      stroke: none;
    }
  }
  .\\[\\&\\>svg\\>path\\]\\:stroke-primary-500 {
    &>svg>path {
      stroke: var(--color-primary-500);
    }
  }
  .\\[\\&\\>svg\\>path\\]\\:stroke-primary-700 {
    &>svg>path {
      stroke: var(--color-primary-700);
    }
  }
  .\\[\\&\\>svg\\>path\\]\\:stroke-textLink {
    &>svg>path {
      stroke: var(--color-textLink);
    }
  }
  .\\[\\&\\>svg\\>path\\]\\:stroke-textLinkPressed {
    &>svg>path {
      stroke: var(--color-textLinkPressed);
    }
  }
  .\\[\\&\\>svg\\>path\\]\\:stroke-textOnColor {
    &>svg>path {
      stroke: var(--color-textOnColor);
    }
  }
  .hover\\:\\[\\&\\>svg\\>path\\]\\:stroke-primary-600 {
    &:hover {
      @media (hover: hover) {
        &>svg>path {
          stroke: var(--color-primary-600);
        }
      }
    }
  }
  .hover\\:\\[\\&\\>svg\\>path\\]\\:stroke-textLinkHover {
    &:hover {
      @media (hover: hover) {
        &>svg>path {
          stroke: var(--color-textLinkHover);
        }
      }
    }
  }
  .active\\:\\[\\&\\>svg\\>path\\]\\:stroke-primary-700 {
    &:active {
      &>svg>path {
        stroke: var(--color-primary-700);
      }
    }
  }
  .active\\:\\[\\&\\>svg\\>path\\]\\:stroke-textLinkPressed {
    &:active {
      &>svg>path {
        stroke: var(--color-textLinkPressed);
      }
    }
  }
  .disabled\\:\\[\\&\\>svg\\>path\\]\\:fill-iconDisabled {
    &:disabled {
      &>svg>path {
        fill: var(--color-iconDisabled);
      }
    }
  }
  .disabled\\:\\[\\&\\>svg\\>path\\]\\:stroke-iconDisabled {
    &:disabled {
      &>svg>path {
        stroke: var(--color-iconDisabled);
      }
    }
  }
  .disabled\\:\\[\\&\\>svg\\>path\\]\\:stroke-none {
    &:disabled {
      &>svg>path {
        stroke: none;
      }
    }
  }
  .disabled\\:\\[\\&\\>svg\\>path\\]\\:stroke-textDisabled {
    &:disabled {
      &>svg>path {
        stroke: var(--color-textDisabled);
      }
    }
  }
}
ul {
  list-style: disc;
  padding-inline-start: 40px;
}
@layer components {
  .text-heading-1 {
    font-size: var(--text-5xl);
    line-height: var(--tw-leading, var(--text-5xl--line-height));
    --tw-leading: 50px;
    line-height: 50px;
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    color: var(--color-black);
  }
  .text-heading-2 {
    font-size: var(--text-3xl);
    line-height: var(--tw-leading, var(--text-3xl--line-height));
    --tw-leading: 48px;
    line-height: 48px;
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    color: var(--color-black);
  }
  .text-heading-3 {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
    --tw-leading: var(--leading-loose);
    line-height: var(--leading-loose);
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    color: var(--color-black);
  }
  .text-heading-4 {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
    --tw-leading: calc(var(--spacing) * 7);
    line-height: calc(var(--spacing) * 7);
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    color: var(--color-black);
  }
  .text-heading-5 {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    --tw-leading: var(--leading-normal);
    line-height: var(--leading-normal);
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    color: var(--color-black);
  }
  .text-heading-6 {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-leading: var(--leading-tight);
    line-height: var(--leading-tight);
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    color: var(--color-black);
  }
  .text-subheading-1 {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
    --tw-leading: var(--leading-loose);
    line-height: var(--leading-loose);
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--color-black);
  }
  .text-subheading-2 {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
    --tw-leading: calc(var(--spacing) * 7);
    line-height: calc(var(--spacing) * 7);
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--color-black);
  }
  .text-L {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    --tw-leading: var(--leading-normal);
    line-height: var(--leading-normal);
    color: var(--color-black);
  }
  .text-M {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-leading: calc(var(--spacing) * 5);
    line-height: calc(var(--spacing) * 5);
    color: var(--color-black);
  }
  .text-S {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    --tw-leading: 1;
    line-height: 1;
    color: var(--color-black);
  }
  .text-XS {
    font-size: 10px;
    --tw-leading: 1;
    line-height: 1;
    color: var(--color-black);
  }
}
.font-base {
  font-family: "Inter", "Helvetica", "Arial", sans-serif;
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-scale-x {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-y {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-z {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-space-x-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-gradient-position {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-via {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-to {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-via-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 0%;
}
@property --tw-gradient-via-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 50%;
}
@property --tw-gradient-to-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@property --tw-content {
  syntax: "*";
  initial-value: "";
  inherits: false;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-scale-x: 1;
      --tw-scale-y: 1;
      --tw-scale-z: 1;
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-space-y-reverse: 0;
      --tw-space-x-reverse: 0;
      --tw-border-style: solid;
      --tw-gradient-position: initial;
      --tw-gradient-from: #0000;
      --tw-gradient-via: #0000;
      --tw-gradient-to: #0000;
      --tw-gradient-stops: initial;
      --tw-gradient-via-stops: initial;
      --tw-gradient-from-position: 0%;
      --tw-gradient-via-position: 50%;
      --tw-gradient-to-position: 100%;
      --tw-leading: initial;
      --tw-font-weight: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-outline-style: solid;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-backdrop-blur: initial;
      --tw-backdrop-brightness: initial;
      --tw-backdrop-contrast: initial;
      --tw-backdrop-grayscale: initial;
      --tw-backdrop-hue-rotate: initial;
      --tw-backdrop-invert: initial;
      --tw-backdrop-opacity: initial;
      --tw-backdrop-saturate: initial;
      --tw-backdrop-sepia: initial;
      --tw-duration: initial;
      --tw-ease: initial;
      --tw-content: "";
    }
  }
}
`, "",{"version":3,"sources":["<no source>","webpack://./node_modules/tailwindcss/index.css","webpack://./client/styles.css"],"names":[],"mappings":"AAAA,kEAAA;ACs3BE,iBAAmB;AAt3BrB,yCAAyC;AAEzC;EACE;IACE;6DAEyD;IAEzD;8BAE0B;IAO1B,0CAA0C;IAC1C,0CAA0C;IAuH1C,4CAA4C;IAC5C,4CAA4C;ICiB9C,wBAAyB;IAEzB,yBAA0B;IAE1B,yBAA0B;IAC1B,yBAA0B;IAE1B,yBAA0B;IAE1B,yBAA0B;IAC1B,yBAA0B;IAC1B,yBAA0B;IAb1B,sBAAuB;IADvB,sBAAuB;ID+HrB,kBAAkB;IAsBlB,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,0CAA0C;IAC1C,iBAAiB;IACjB,uCAAuC;IACvC,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,sCAAsC;IACtC,oBAAoB;IACpB,2CAA2C;IAG3C,gBAAgB;IAChB,0BAA0B;IAc1B,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IAWvB,qBAAqB;IAErB,qBAAqB;IAErB,kBAAkB;IAGlB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAsClB,qCAAqC;IAErC,2CAA2C;IAE3C,uCAAuC;IAyCvC,eAAe;IAaf,oCAAoC;IACpC,kEAAkE;IAClE,uCAAoD;IASpD,4CAAyD;ICnZ3D,yCAA0C;IAC1C,yCAA0C;IAC1C,yCAA0C;IAG1C,uCAAwC;IACxC,2CAA4C;IAG5C,0CAA2C;IAC3C,4CAA6C;IAC7C,2CAA4C;IAC5C,0CAA2C;IAC3C,+CAAgD;IAChD,iDAAkD;IAClD,2CAA4C;IAC5C,yCAA0C;IAG1C,uCAAwC;IAExC,4CAA6C;IAC7C,iDAAkD;IAClD,mDAAoD;IACpD,yCAA0C;IAC1C,wCAAyC;IACzC,iDAAkD;IAClD,+CAAgD;IAChD,kDAAmD;IACnD,4CAA6C;IAC7C,kDAAmD;IACnD,oDAAqD;IACrD,kDAAmD;IACnD,qDAAsD;IAEtD,4CAA6C;IAE7C,0CAA2C;IAC3C,+CAAgD;IAChD,wDAAyD;IACzD,kDAAmD;IAInD,wCAAyC;IAEzC,6CAA8C;IAC9C,mDAAoD;IAKpD,6CAA8C;IAC9C,4CAA6C;IAC7C,2CAA4C;IAC5C,uCAAwC;IACxC,2CAA4C;IAC5C,yCAA0C;IAE1C,6CAA8C;IAE9C,wCAAyC;IACzC,wCAAyC;IAEzC,wCAAyC;IAEzC,oDAAqD;IACrD,kDAAmD;IACnD,8CAA+C;IAC/C,2CAA4C;IAC5C,oDAAqD;IAGrD,0CAA2C;IAC3C,qDAAsD;IACtD,yDAA0D;IAE1D,8CAA+C;IAC/C,yDAA0D;IAC1D,6DAA8D;IAE9D,mDAAoD;IACpD,uDAAwD;IAExD,6CAA8C;IAC9C,wDAAyD;IACzD,4DAA6D;IAQ7D,+BAAgC;IAIhC,yBAA0B;IAU1B,2BAA4B;IAC5B,4BAA6B;IAC7B,4BAA6B;IAG7B,4BAA6B;IAC7B,4BAA6B;IAC7B,4BAA6B;IAK7B,0BAA2B;IAI3B,0BAA2B;IAO3B,4BAA6B;IAI7B,4BAA6B;IAO7B,4BAA6B;IAI7B,4BAA6B;ED3Md;AADJ;AAmeb;EAOE;IAKE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,eAAe;EAJM;EAiBvB;IAEE,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,2JASC;IACD,mEAGC;IACD,uEAGC;IACD,wCAAwC;EAtBpC;EA+BN;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EAHpB;EAUH;IACE,yCAAyC;IACzC,iCAAiC;EAFf;EASpB;IAME,kBAAkB;IAClB,oBAAoB;EAFnB;EASH;IACE,cAAc;IACd,gCAAgC;IAChC,wBAAwB;EAHxB;EAUF;IAEE,mBAAmB;EADd;EAWP;IAIE,gJAUC;IACD,wEAGC;IACD,4EAGC;IACD,cAAc;EApBZ;EA2BJ;IACE,cAAc;EADV;EAQN;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAJtB;EAOJ;IACE,eAAe;EADb;EAIJ;IACE,WAAW;EADT;EAUJ;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAHrB;EAUN;IACE,aAAa;EADC;EAQhB;IACE,wBAAwB;EADjB;EAQT;IACE,kBAAkB;EADZ;EAQR;IAGE,gBAAgB;EADb;EAUL;IAQE,cAAc;IACd,sBAAsB;EAFjB;EASP;IAEE,eAAe;IACf,YAAY;EAFR;EAYN;IAME,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EARW;EAevB;IACE,mBAAmB;EAD0B;EAQ/C;IACE,0BAA0B;EAD0B;EAQtD;IACE,sBAAsB;EADD;EAQvB;IACE,UAAU;EADE;EASd;IAEE;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;EADiC;EAUjD;IACE,gBAAgB;EADT;EAQT;IACE,wBAAwB;EADE;EAS5B;IACE,eAAe;IACf,mBAAmB;EAFS;EAS9B;IACE,oBAAoB;EADE;EAQxB;IACE,UAAU;EAD2B;EAIvC;IASE,gBAAgB;EADqB;EAQvC;IACE,gBAAgB;EADD;EAQjB;IAGE,kBAAkB;EADG;EAQvB;IAEE,YAAY;EADc;EAQ5B;IACE,wBAAwB;EADmB;AA3YnC;AAgZZ;EACE;IAAA,oBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,UAAmB;IAAnB,WAAmB;IAAnB,UAAmB;IAAnB,YAAmB;IAAnB,gBAAmB;IAAnB,sBAAmB;IAAnB,mBAAmB;IAAnB,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,oBAAmB;IAAnB,4BAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,OAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,kBAAmB;IAAnB,kBAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,0GAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,+EAAmB;MAAnB,uFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,+EAAmB;MAAnB,uFAAmB;IAAA;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,+CAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,sDAAmB;IAAnB,mCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,yBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,8BAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,oBAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,8BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,0DAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,uDAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,yEAAmB;IAAnB;MAAA,2FAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,6DAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,6DAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,8DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,8DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,8DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,6DAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yDAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,6DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,+BAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,iDAAmB;IAAnB,gDAAmB;EAAA;EAAnB;IAAA,iDAAmB;IAAnB,gDAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,wCAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,0HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,oEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,6HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,mFAAmB;IAAA;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,0LAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,wRAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,qVAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,qDAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,uKAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wDAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,8CAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,oBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA;MAAA;QAAA,sCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,gBAAmB;MAAnB,0BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;MAAnB,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,sCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,0CAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,6DAAmB;QAAnB;UAAA,yEAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,8CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,sCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,8BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,8BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,6BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;QAAnB,oBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;MAAnB,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,qCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,0CAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,2CAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,6BAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,gCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,gCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA;YAAA,qCAAmB;UAAA;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA;YAAA,yCAAmB;UAAA;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;MAAnB,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0HAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,qFAAmB;MAAnB,2EAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,gDAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,sBAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;MAAnB,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,iCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,sCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,wCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,6BAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,iCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,sCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,6BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uKAAmB;MAAnB,qFAAmB;MAAnB,2EAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,8BAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,gCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,gCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,kCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,YAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iCAAmB;MAAA;IAAA;EAAA;AADJ;ACn3BjB;EACE,gBAAiB;EACjB,0BAA2B;AAC5B;AAED;EAKE;IACoB,0BAAQ;IAAR,4DAAQ;IAAe,kBAAc;IAAd,iBAAc;IAA5B,6CAAa;IAAb,wCAAa;IAAjC,yBAAU;EAClB;EACD;IACoB,0BAAQ;IAAR,4DAAQ;IAAe,kBAAc;IAAd,iBAAc;IAA5B,6CAAa;IAAb,wCAAa;IAAjC,yBAAU;EAClB;EACD;IACoB,0BAAQ;IAAR,4DAAQ;IAAe,kCAAa;IAAb,iCAAa;IAA3B,6CAAa;IAAb,wCAAa;IAAjC,yBAAU;EAClB;EACD;IACoB,yBAAO;IAAP,2DAAO;IAAe,sCAAS;IAAT,qCAAS;IAAvB,6CAAa;IAAb,wCAAa;IAAhC,yBAAU;EAClB;EACD;IACoB,2BAAS;IAAT,6DAAS;IAAe,mCAAc;IAAd,kCAAc;IAA5B,6CAAa;IAAb,wCAAa;IAAlC,yBAAU;EAClB;EACD;IACoB,yBAAO;IAAP,2DAAO;IAAe,kCAAa;IAAb,iCAAa;IAA3B,6CAAa;IAAb,wCAAa;IAAhC,yBAAU;EAClB;EACD;IACoB,0BAAQ;IAAR,4DAAQ;IAAa,kCAAa;IAAb,iCAAa;IAAzB,2CAAW;IAAX,sCAAW;IAA/B,yBAAU;EAClB;EACD;IACoB,yBAAO;IAAP,2DAAO;IAAa,sCAAS;IAAT,qCAAS;IAArB,2CAAW;IAAX,sCAAW;IAA9B,yBAAU;EAClB;EACD;IACoB,2BAAS;IAAT,6DAAS;IAAC,mCAAc;IAAd,kCAAc;IAAnC,yBAAU;EAClB;EACD;IACoB,yBAAO;IAAP,2DAAO;IAAC,sCAAS;IAAT,qCAAS;IAA5B,yBAAU;EAClB;EACD;IACoB,yBAAO;IAAP,2DAAO;IAAC,eAAY;IAAZ,cAAY;IAA/B,yBAAU;EAClB;EACD;IACoB,eAAW;IAAC,eAAY;IAAZ,cAAY;IAAnC,yBAAU;EAClB;AAGF;AACD;EACE,sDAAuD;AACxD;ADi0BC;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,iBAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,iBAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,iBAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,6BAAmB;EAAnB,eAAmB;EAAnB,iBAAmB;AAAA;AAAnB;EAAA,6BAAmB;EAAnB,eAAmB;EAAnB,kBAAmB;AAAA;AAAnB;EAAA,6BAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB,eAAmB;EAAnB,kBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,iBAAmB;EAAnB,eAAmB;AAAA;AAnejB;EACE;IACE,yBAAyB;EADxB;AADW;AAmelB;EAAA;IAAA;MAAA,mBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,eAAmB;MAAnB,eAAmB;MAAnB,eAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,oBAAmB;MAAnB,oBAAmB;MAAnB,uBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,+BAAmB;MAAnB,yBAAmB;MAAnB,wBAAmB;MAAnB,uBAAmB;MAAnB,4BAAmB;MAAnB,gCAAmB;MAAnB,+BAAmB;MAAnB,+BAAmB;MAAnB,+BAAmB;MAAnB,qBAAmB;MAAnB,yBAAmB;MAAnB,sBAAmB;MAAnB,0BAAmB;MAAnB,uBAAmB;MAAnB,4BAAmB;MAAnB,gCAAmB;MAAnB,6BAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,8BAAmB;MAAnB,iCAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,4BAAmB;MAAnB,kCAAmB;MAAnB,yBAAmB;MAAnB,kBAAmB;MAAnB,wBAAmB;MAAnB,sBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,oBAAmB;MAAnB,qBAAmB;MAAnB,sBAAmB;MAAnB,mBAAmB;MAAnB,yBAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,8BAAmB;MAAnB,2BAAmB;MAAnB,iCAAmB;MAAnB,+BAAmB;MAAnB,gCAAmB;MAAnB,iCAAmB;MAAnB,6BAAmB;MAAnB,8BAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,sBAAmB;MAAnB,kBAAmB;MAAnB,gBAAmB;IAAA;EAAA;AAAA","sourcesContent":[null,"@layer theme, base, components, utilities;\n\n@layer theme {\n  @theme default {\n    --font-sans:\n      ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\",\n      \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-serif: ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif;\n    --font-mono:\n      ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n      \"Courier New\", monospace;\n\n    --color-red-50: oklch(97.1% 0.013 17.38);\n    --color-red-100: oklch(93.6% 0.032 17.717);\n    --color-red-200: oklch(88.5% 0.062 18.334);\n    --color-red-300: oklch(80.8% 0.114 19.571);\n    --color-red-400: oklch(70.4% 0.191 22.216);\n    --color-red-500: oklch(63.7% 0.237 25.331);\n    --color-red-600: oklch(57.7% 0.245 27.325);\n    --color-red-700: oklch(50.5% 0.213 27.518);\n    --color-red-800: oklch(44.4% 0.177 26.899);\n    --color-red-900: oklch(39.6% 0.141 25.723);\n    --color-red-950: oklch(25.8% 0.092 26.042);\n\n    --color-orange-50: oklch(98% 0.016 73.684);\n    --color-orange-100: oklch(95.4% 0.038 75.164);\n    --color-orange-200: oklch(90.1% 0.076 70.697);\n    --color-orange-300: oklch(83.7% 0.128 66.29);\n    --color-orange-400: oklch(75% 0.183 55.934);\n    --color-orange-500: oklch(70.5% 0.213 47.604);\n    --color-orange-600: oklch(64.6% 0.222 41.116);\n    --color-orange-700: oklch(55.3% 0.195 38.402);\n    --color-orange-800: oklch(47% 0.157 37.304);\n    --color-orange-900: oklch(40.8% 0.123 38.172);\n    --color-orange-950: oklch(26.6% 0.079 36.259);\n\n    --color-amber-50: oklch(98.7% 0.022 95.277);\n    --color-amber-100: oklch(96.2% 0.059 95.617);\n    --color-amber-200: oklch(92.4% 0.12 95.746);\n    --color-amber-300: oklch(87.9% 0.169 91.605);\n    --color-amber-400: oklch(82.8% 0.189 84.429);\n    --color-amber-500: oklch(76.9% 0.188 70.08);\n    --color-amber-600: oklch(66.6% 0.179 58.318);\n    --color-amber-700: oklch(55.5% 0.163 48.998);\n    --color-amber-800: oklch(47.3% 0.137 46.201);\n    --color-amber-900: oklch(41.4% 0.112 45.904);\n    --color-amber-950: oklch(27.9% 0.077 45.635);\n\n    --color-yellow-50: oklch(98.7% 0.026 102.212);\n    --color-yellow-100: oklch(97.3% 0.071 103.193);\n    --color-yellow-200: oklch(94.5% 0.129 101.54);\n    --color-yellow-300: oklch(90.5% 0.182 98.111);\n    --color-yellow-400: oklch(85.2% 0.199 91.936);\n    --color-yellow-500: oklch(79.5% 0.184 86.047);\n    --color-yellow-600: oklch(68.1% 0.162 75.834);\n    --color-yellow-700: oklch(55.4% 0.135 66.442);\n    --color-yellow-800: oklch(47.6% 0.114 61.907);\n    --color-yellow-900: oklch(42.1% 0.095 57.708);\n    --color-yellow-950: oklch(28.6% 0.066 53.813);\n\n    --color-lime-50: oklch(98.6% 0.031 120.757);\n    --color-lime-100: oklch(96.7% 0.067 122.328);\n    --color-lime-200: oklch(93.8% 0.127 124.321);\n    --color-lime-300: oklch(89.7% 0.196 126.665);\n    --color-lime-400: oklch(84.1% 0.238 128.85);\n    --color-lime-500: oklch(76.8% 0.233 130.85);\n    --color-lime-600: oklch(64.8% 0.2 131.684);\n    --color-lime-700: oklch(53.2% 0.157 131.589);\n    --color-lime-800: oklch(45.3% 0.124 130.933);\n    --color-lime-900: oklch(40.5% 0.101 131.063);\n    --color-lime-950: oklch(27.4% 0.072 132.109);\n\n    --color-green-50: oklch(98.2% 0.018 155.826);\n    --color-green-100: oklch(96.2% 0.044 156.743);\n    --color-green-200: oklch(92.5% 0.084 155.995);\n    --color-green-300: oklch(87.1% 0.15 154.449);\n    --color-green-400: oklch(79.2% 0.209 151.711);\n    --color-green-500: oklch(72.3% 0.219 149.579);\n    --color-green-600: oklch(62.7% 0.194 149.214);\n    --color-green-700: oklch(52.7% 0.154 150.069);\n    --color-green-800: oklch(44.8% 0.119 151.328);\n    --color-green-900: oklch(39.3% 0.095 152.535);\n    --color-green-950: oklch(26.6% 0.065 152.934);\n\n    --color-emerald-50: oklch(97.9% 0.021 166.113);\n    --color-emerald-100: oklch(95% 0.052 163.051);\n    --color-emerald-200: oklch(90.5% 0.093 164.15);\n    --color-emerald-300: oklch(84.5% 0.143 164.978);\n    --color-emerald-400: oklch(76.5% 0.177 163.223);\n    --color-emerald-500: oklch(69.6% 0.17 162.48);\n    --color-emerald-600: oklch(59.6% 0.145 163.225);\n    --color-emerald-700: oklch(50.8% 0.118 165.612);\n    --color-emerald-800: oklch(43.2% 0.095 166.913);\n    --color-emerald-900: oklch(37.8% 0.077 168.94);\n    --color-emerald-950: oklch(26.2% 0.051 172.552);\n\n    --color-teal-50: oklch(98.4% 0.014 180.72);\n    --color-teal-100: oklch(95.3% 0.051 180.801);\n    --color-teal-200: oklch(91% 0.096 180.426);\n    --color-teal-300: oklch(85.5% 0.138 181.071);\n    --color-teal-400: oklch(77.7% 0.152 181.912);\n    --color-teal-500: oklch(70.4% 0.14 182.503);\n    --color-teal-600: oklch(60% 0.118 184.704);\n    --color-teal-700: oklch(51.1% 0.096 186.391);\n    --color-teal-800: oklch(43.7% 0.078 188.216);\n    --color-teal-900: oklch(38.6% 0.063 188.416);\n    --color-teal-950: oklch(27.7% 0.046 192.524);\n\n    --color-cyan-50: oklch(98.4% 0.019 200.873);\n    --color-cyan-100: oklch(95.6% 0.045 203.388);\n    --color-cyan-200: oklch(91.7% 0.08 205.041);\n    --color-cyan-300: oklch(86.5% 0.127 207.078);\n    --color-cyan-400: oklch(78.9% 0.154 211.53);\n    --color-cyan-500: oklch(71.5% 0.143 215.221);\n    --color-cyan-600: oklch(60.9% 0.126 221.723);\n    --color-cyan-700: oklch(52% 0.105 223.128);\n    --color-cyan-800: oklch(45% 0.085 224.283);\n    --color-cyan-900: oklch(39.8% 0.07 227.392);\n    --color-cyan-950: oklch(30.2% 0.056 229.695);\n\n    --color-sky-50: oklch(97.7% 0.013 236.62);\n    --color-sky-100: oklch(95.1% 0.026 236.824);\n    --color-sky-200: oklch(90.1% 0.058 230.902);\n    --color-sky-300: oklch(82.8% 0.111 230.318);\n    --color-sky-400: oklch(74.6% 0.16 232.661);\n    --color-sky-500: oklch(68.5% 0.169 237.323);\n    --color-sky-600: oklch(58.8% 0.158 241.966);\n    --color-sky-700: oklch(50% 0.134 242.749);\n    --color-sky-800: oklch(44.3% 0.11 240.79);\n    --color-sky-900: oklch(39.1% 0.09 240.876);\n    --color-sky-950: oklch(29.3% 0.066 243.157);\n\n    --color-blue-50: oklch(97% 0.014 254.604);\n    --color-blue-100: oklch(93.2% 0.032 255.585);\n    --color-blue-200: oklch(88.2% 0.059 254.128);\n    --color-blue-300: oklch(80.9% 0.105 251.813);\n    --color-blue-400: oklch(70.7% 0.165 254.624);\n    --color-blue-500: oklch(62.3% 0.214 259.815);\n    --color-blue-600: oklch(54.6% 0.245 262.881);\n    --color-blue-700: oklch(48.8% 0.243 264.376);\n    --color-blue-800: oklch(42.4% 0.199 265.638);\n    --color-blue-900: oklch(37.9% 0.146 265.522);\n    --color-blue-950: oklch(28.2% 0.091 267.935);\n\n    --color-indigo-50: oklch(96.2% 0.018 272.314);\n    --color-indigo-100: oklch(93% 0.034 272.788);\n    --color-indigo-200: oklch(87% 0.065 274.039);\n    --color-indigo-300: oklch(78.5% 0.115 274.713);\n    --color-indigo-400: oklch(67.3% 0.182 276.935);\n    --color-indigo-500: oklch(58.5% 0.233 277.117);\n    --color-indigo-600: oklch(51.1% 0.262 276.966);\n    --color-indigo-700: oklch(45.7% 0.24 277.023);\n    --color-indigo-800: oklch(39.8% 0.195 277.366);\n    --color-indigo-900: oklch(35.9% 0.144 278.697);\n    --color-indigo-950: oklch(25.7% 0.09 281.288);\n\n    --color-violet-50: oklch(96.9% 0.016 293.756);\n    --color-violet-100: oklch(94.3% 0.029 294.588);\n    --color-violet-200: oklch(89.4% 0.057 293.283);\n    --color-violet-300: oklch(81.1% 0.111 293.571);\n    --color-violet-400: oklch(70.2% 0.183 293.541);\n    --color-violet-500: oklch(60.6% 0.25 292.717);\n    --color-violet-600: oklch(54.1% 0.281 293.009);\n    --color-violet-700: oklch(49.1% 0.27 292.581);\n    --color-violet-800: oklch(43.2% 0.232 292.759);\n    --color-violet-900: oklch(38% 0.189 293.745);\n    --color-violet-950: oklch(28.3% 0.141 291.089);\n\n    --color-purple-50: oklch(97.7% 0.014 308.299);\n    --color-purple-100: oklch(94.6% 0.033 307.174);\n    --color-purple-200: oklch(90.2% 0.063 306.703);\n    --color-purple-300: oklch(82.7% 0.119 306.383);\n    --color-purple-400: oklch(71.4% 0.203 305.504);\n    --color-purple-500: oklch(62.7% 0.265 303.9);\n    --color-purple-600: oklch(55.8% 0.288 302.321);\n    --color-purple-700: oklch(49.6% 0.265 301.924);\n    --color-purple-800: oklch(43.8% 0.218 303.724);\n    --color-purple-900: oklch(38.1% 0.176 304.987);\n    --color-purple-950: oklch(29.1% 0.149 302.717);\n\n    --color-fuchsia-50: oklch(97.7% 0.017 320.058);\n    --color-fuchsia-100: oklch(95.2% 0.037 318.852);\n    --color-fuchsia-200: oklch(90.3% 0.076 319.62);\n    --color-fuchsia-300: oklch(83.3% 0.145 321.434);\n    --color-fuchsia-400: oklch(74% 0.238 322.16);\n    --color-fuchsia-500: oklch(66.7% 0.295 322.15);\n    --color-fuchsia-600: oklch(59.1% 0.293 322.896);\n    --color-fuchsia-700: oklch(51.8% 0.253 323.949);\n    --color-fuchsia-800: oklch(45.2% 0.211 324.591);\n    --color-fuchsia-900: oklch(40.1% 0.17 325.612);\n    --color-fuchsia-950: oklch(29.3% 0.136 325.661);\n\n    --color-pink-50: oklch(97.1% 0.014 343.198);\n    --color-pink-100: oklch(94.8% 0.028 342.258);\n    --color-pink-200: oklch(89.9% 0.061 343.231);\n    --color-pink-300: oklch(82.3% 0.12 346.018);\n    --color-pink-400: oklch(71.8% 0.202 349.761);\n    --color-pink-500: oklch(65.6% 0.241 354.308);\n    --color-pink-600: oklch(59.2% 0.249 0.584);\n    --color-pink-700: oklch(52.5% 0.223 3.958);\n    --color-pink-800: oklch(45.9% 0.187 3.815);\n    --color-pink-900: oklch(40.8% 0.153 2.432);\n    --color-pink-950: oklch(28.4% 0.109 3.907);\n\n    --color-rose-50: oklch(96.9% 0.015 12.422);\n    --color-rose-100: oklch(94.1% 0.03 12.58);\n    --color-rose-200: oklch(89.2% 0.058 10.001);\n    --color-rose-300: oklch(81% 0.117 11.638);\n    --color-rose-400: oklch(71.2% 0.194 13.428);\n    --color-rose-500: oklch(64.5% 0.246 16.439);\n    --color-rose-600: oklch(58.6% 0.253 17.585);\n    --color-rose-700: oklch(51.4% 0.222 16.935);\n    --color-rose-800: oklch(45.5% 0.188 13.697);\n    --color-rose-900: oklch(41% 0.159 10.272);\n    --color-rose-950: oklch(27.1% 0.105 12.094);\n\n    --color-slate-50: oklch(98.4% 0.003 247.858);\n    --color-slate-100: oklch(96.8% 0.007 247.896);\n    --color-slate-200: oklch(92.9% 0.013 255.508);\n    --color-slate-300: oklch(86.9% 0.022 252.894);\n    --color-slate-400: oklch(70.4% 0.04 256.788);\n    --color-slate-500: oklch(55.4% 0.046 257.417);\n    --color-slate-600: oklch(44.6% 0.043 257.281);\n    --color-slate-700: oklch(37.2% 0.044 257.287);\n    --color-slate-800: oklch(27.9% 0.041 260.031);\n    --color-slate-900: oklch(20.8% 0.042 265.755);\n    --color-slate-950: oklch(12.9% 0.042 264.695);\n\n    --color-gray-50: oklch(98.5% 0.002 247.839);\n    --color-gray-100: oklch(96.7% 0.003 264.542);\n    --color-gray-200: oklch(92.8% 0.006 264.531);\n    --color-gray-300: oklch(87.2% 0.01 258.338);\n    --color-gray-400: oklch(70.7% 0.022 261.325);\n    --color-gray-500: oklch(55.1% 0.027 264.364);\n    --color-gray-600: oklch(44.6% 0.03 256.802);\n    --color-gray-700: oklch(37.3% 0.034 259.733);\n    --color-gray-800: oklch(27.8% 0.033 256.848);\n    --color-gray-900: oklch(21% 0.034 264.665);\n    --color-gray-950: oklch(13% 0.028 261.692);\n\n    --color-zinc-50: oklch(98.5% 0 0);\n    --color-zinc-100: oklch(96.7% 0.001 286.375);\n    --color-zinc-200: oklch(92% 0.004 286.32);\n    --color-zinc-300: oklch(87.1% 0.006 286.286);\n    --color-zinc-400: oklch(70.5% 0.015 286.067);\n    --color-zinc-500: oklch(55.2% 0.016 285.938);\n    --color-zinc-600: oklch(44.2% 0.017 285.786);\n    --color-zinc-700: oklch(37% 0.013 285.805);\n    --color-zinc-800: oklch(27.4% 0.006 286.033);\n    --color-zinc-900: oklch(21% 0.006 285.885);\n    --color-zinc-950: oklch(14.1% 0.005 285.823);\n\n    --color-neutral-50: oklch(98.5% 0 0);\n    --color-neutral-100: oklch(97% 0 0);\n    --color-neutral-200: oklch(92.2% 0 0);\n    --color-neutral-300: oklch(87% 0 0);\n    --color-neutral-400: oklch(70.8% 0 0);\n    --color-neutral-500: oklch(55.6% 0 0);\n    --color-neutral-600: oklch(43.9% 0 0);\n    --color-neutral-700: oklch(37.1% 0 0);\n    --color-neutral-800: oklch(26.9% 0 0);\n    --color-neutral-900: oklch(20.5% 0 0);\n    --color-neutral-950: oklch(14.5% 0 0);\n\n    --color-stone-50: oklch(98.5% 0.001 106.423);\n    --color-stone-100: oklch(97% 0.001 106.424);\n    --color-stone-200: oklch(92.3% 0.003 48.717);\n    --color-stone-300: oklch(86.9% 0.005 56.366);\n    --color-stone-400: oklch(70.9% 0.01 56.259);\n    --color-stone-500: oklch(55.3% 0.013 58.071);\n    --color-stone-600: oklch(44.4% 0.011 73.639);\n    --color-stone-700: oklch(37.4% 0.01 67.558);\n    --color-stone-800: oklch(26.8% 0.007 34.298);\n    --color-stone-900: oklch(21.6% 0.006 56.043);\n    --color-stone-950: oklch(14.7% 0.004 49.25);\n\n    --color-black: #000;\n    --color-white: #fff;\n\n    --spacing: 0.25rem;\n\n    --breakpoint-sm: 40rem;\n    --breakpoint-md: 48rem;\n    --breakpoint-lg: 64rem;\n    --breakpoint-xl: 80rem;\n    --breakpoint-2xl: 96rem;\n\n    --container-3xs: 16rem;\n    --container-2xs: 18rem;\n    --container-xs: 20rem;\n    --container-sm: 24rem;\n    --container-md: 28rem;\n    --container-lg: 32rem;\n    --container-xl: 36rem;\n    --container-2xl: 42rem;\n    --container-3xl: 48rem;\n    --container-4xl: 56rem;\n    --container-5xl: 64rem;\n    --container-6xl: 72rem;\n    --container-7xl: 80rem;\n\n    --text-xs: 0.75rem;\n    --text-xs--line-height: calc(1 / 0.75);\n    --text-sm: 0.875rem;\n    --text-sm--line-height: calc(1.25 / 0.875);\n    --text-base: 1rem;\n    --text-base--line-height: calc(1.5 / 1);\n    --text-lg: 1.125rem;\n    --text-lg--line-height: calc(1.75 / 1.125);\n    --text-xl: 1.25rem;\n    --text-xl--line-height: calc(1.75 / 1.25);\n    --text-2xl: 1.5rem;\n    --text-2xl--line-height: calc(2 / 1.5);\n    --text-3xl: 1.875rem;\n    --text-3xl--line-height: calc(2.25 / 1.875);\n    --text-4xl: 2.25rem;\n    --text-4xl--line-height: calc(2.5 / 2.25);\n    --text-5xl: 3rem;\n    --text-5xl--line-height: 1;\n    --text-6xl: 3.75rem;\n    --text-6xl--line-height: 1;\n    --text-7xl: 4.5rem;\n    --text-7xl--line-height: 1;\n    --text-8xl: 6rem;\n    --text-8xl--line-height: 1;\n    --text-9xl: 8rem;\n    --text-9xl--line-height: 1;\n\n    --font-weight-thin: 100;\n    --font-weight-extralight: 200;\n    --font-weight-light: 300;\n    --font-weight-normal: 400;\n    --font-weight-medium: 500;\n    --font-weight-semibold: 600;\n    --font-weight-bold: 700;\n    --font-weight-extrabold: 800;\n    --font-weight-black: 900;\n\n    --tracking-tighter: -0.05em;\n    --tracking-tight: -0.025em;\n    --tracking-normal: 0em;\n    --tracking-wide: 0.025em;\n    --tracking-wider: 0.05em;\n    --tracking-widest: 0.1em;\n\n    --leading-tight: 1.25;\n    --leading-snug: 1.375;\n    --leading-normal: 1.5;\n    --leading-relaxed: 1.625;\n    --leading-loose: 2;\n\n    --radius-xs: 0.125rem;\n    --radius-sm: 0.25rem;\n    --radius-md: 0.375rem;\n    --radius-lg: 0.5rem;\n    --radius-xl: 0.75rem;\n    --radius-2xl: 1rem;\n    --radius-3xl: 1.5rem;\n    --radius-4xl: 2rem;\n\n    --shadow-2xs: 0 1px rgb(0 0 0 / 0.05);\n    --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n    --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-md:\n      0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n    --shadow-lg:\n      0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --shadow-xl:\n      0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n    --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n\n    --inset-shadow-2xs: inset 0 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-xs: inset 0 1px 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-sm: inset 0 2px 4px rgb(0 0 0 / 0.05);\n\n    --drop-shadow-xs: 0 1px 1px rgb(0 0 0 / 0.05);\n    --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);\n    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);\n    --drop-shadow-lg: 0 4px 4px rgb(0 0 0 / 0.15);\n    --drop-shadow-xl: 0 9px 7px rgb(0 0 0 / 0.1);\n    --drop-shadow-2xl: 0 25px 25px rgb(0 0 0 / 0.15);\n\n    --text-shadow-2xs: 0px 1px 0px rgb(0 0 0 / 0.15);\n    --text-shadow-xs: 0px 1px 1px rgb(0 0 0 / 0.2);\n    --text-shadow-sm:\n      0px 1px 0px rgb(0 0 0 / 0.075), 0px 1px 1px rgb(0 0 0 / 0.075),\n      0px 2px 2px rgb(0 0 0 / 0.075);\n    --text-shadow-md:\n      0px 1px 1px rgb(0 0 0 / 0.1), 0px 1px 2px rgb(0 0 0 / 0.1),\n      0px 2px 4px rgb(0 0 0 / 0.1);\n    --text-shadow-lg:\n      0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1),\n      0px 4px 8px rgb(0 0 0 / 0.1);\n\n    --ease-in: cubic-bezier(0.4, 0, 1, 1);\n    --ease-out: cubic-bezier(0, 0, 0.2, 1);\n    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n\n    --animate-spin: spin 1s linear infinite;\n    --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    --animate-bounce: bounce 1s infinite;\n\n    @keyframes spin {\n      to {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes ping {\n      75%,\n      100% {\n        transform: scale(2);\n        opacity: 0;\n      }\n    }\n\n    @keyframes pulse {\n      50% {\n        opacity: 0.5;\n      }\n    }\n\n    @keyframes bounce {\n      0%,\n      100% {\n        transform: translateY(-25%);\n        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n      }\n\n      50% {\n        transform: none;\n        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n      }\n    }\n\n    --blur-xs: 4px;\n    --blur-sm: 8px;\n    --blur-md: 12px;\n    --blur-lg: 16px;\n    --blur-xl: 24px;\n    --blur-2xl: 40px;\n    --blur-3xl: 64px;\n\n    --perspective-dramatic: 100px;\n    --perspective-near: 300px;\n    --perspective-normal: 500px;\n    --perspective-midrange: 800px;\n    --perspective-distant: 1200px;\n\n    --aspect-video: 16 / 9;\n\n    --default-transition-duration: 150ms;\n    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    --default-font-family: --theme(--font-sans, initial);\n    --default-font-feature-settings: --theme(\n      --font-sans--font-feature-settings,\n      initial\n    );\n    --default-font-variation-settings: --theme(\n      --font-sans--font-variation-settings,\n      initial\n    );\n    --default-mono-font-family: --theme(--font-mono, initial);\n    --default-mono-font-feature-settings: --theme(\n      --font-mono--font-feature-settings,\n      initial\n    );\n    --default-mono-font-variation-settings: --theme(\n      --font-mono--font-variation-settings,\n      initial\n    );\n  }\n\n  /* Deprecated */\n  @theme default inline reference {\n    --blur: 8px;\n    --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-inner: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);\n    --drop-shadow: 0 1px 2px rgb(0 0 0 / 0.1), 0 1px 1px rgb(0 0 0 / 0.06);\n    --radius: 0.25rem;\n    --max-width-prose: 65ch;\n  }\n}\n\n@layer base {\n  /*\n  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n  2. Remove default margins and padding\n  3. Reset all borders.\n*/\n\n  *,\n  ::after,\n  ::before,\n  ::backdrop,\n  ::file-selector-button {\n    box-sizing: border-box; /* 1 */\n    margin: 0; /* 2 */\n    padding: 0; /* 2 */\n    border: 0 solid; /* 3 */\n  }\n\n  /*\n  1. Use a consistent sensible line-height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  3. Use a more readable tab size.\n  4. Use the user's configured `sans` font-family by default.\n  5. Use the user's configured `sans` font-feature-settings by default.\n  6. Use the user's configured `sans` font-variation-settings by default.\n  7. Disable tap highlights on iOS.\n*/\n\n  html,\n  :host {\n    line-height: 1.5; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n    tab-size: 4; /* 3 */\n    font-family: --theme(\n      --default-font-family,\n      ui-sans-serif,\n      system-ui,\n      sans-serif,\n      \"Apple Color Emoji\",\n      \"Segoe UI Emoji\",\n      \"Segoe UI Symbol\",\n      \"Noto Color Emoji\"\n    ); /* 4 */\n    font-feature-settings: --theme(\n      --default-font-feature-settings,\n      normal\n    ); /* 5 */\n    font-variation-settings: --theme(\n      --default-font-variation-settings,\n      normal\n    ); /* 6 */\n    -webkit-tap-highlight-color: transparent; /* 7 */\n  }\n\n  /*\n  1. Add the correct height in Firefox.\n  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n  3. Reset the default border style to a 1px solid border.\n*/\n\n  hr {\n    height: 0; /* 1 */\n    color: inherit; /* 2 */\n    border-top-width: 1px; /* 3 */\n  }\n\n  /*\n  Add the correct text decoration in Chrome, Edge, and Safari.\n*/\n\n  abbr:where([title]) {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n\n  /*\n  Remove the default font size and weight for headings.\n*/\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n\n  /*\n  Reset links to optimize for opt-in styling instead of opt-out.\n*/\n\n  a {\n    color: inherit;\n    -webkit-text-decoration: inherit;\n    text-decoration: inherit;\n  }\n\n  /*\n  Add the correct font weight in Edge and Safari.\n*/\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  /*\n  1. Use the user's configured `mono` font-family by default.\n  2. Use the user's configured `mono` font-feature-settings by default.\n  3. Use the user's configured `mono` font-variation-settings by default.\n  4. Correct the odd `em` font sizing in all browsers.\n*/\n\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family: --theme(\n      --default-mono-font-family,\n      ui-monospace,\n      SFMono-Regular,\n      Menlo,\n      Monaco,\n      Consolas,\n      \"Liberation Mono\",\n      \"Courier New\",\n      monospace\n    ); /* 1 */\n    font-feature-settings: --theme(\n      --default-mono-font-feature-settings,\n      normal\n    ); /* 2 */\n    font-variation-settings: --theme(\n      --default-mono-font-variation-settings,\n      normal\n    ); /* 3 */\n    font-size: 1em; /* 4 */\n  }\n\n  /*\n  Add the correct font size in all browsers.\n*/\n\n  small {\n    font-size: 80%;\n  }\n\n  /*\n  Prevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  /*\n  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n  3. Remove gaps between table borders by default.\n*/\n\n  table {\n    text-indent: 0; /* 1 */\n    border-color: inherit; /* 2 */\n    border-collapse: collapse; /* 3 */\n  }\n\n  /*\n  Use the modern Firefox focus style for all focusable elements.\n*/\n\n  :-moz-focusring {\n    outline: auto;\n  }\n\n  /*\n  Add the correct vertical alignment in Chrome and Firefox.\n*/\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  /*\n  Add the correct display in Chrome and Safari.\n*/\n\n  summary {\n    display: list-item;\n  }\n\n  /*\n  Make lists unstyled by default.\n*/\n\n  ol,\n  ul,\n  menu {\n    list-style: none;\n  }\n\n  /*\n  1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n  2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n      This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block; /* 1 */\n    vertical-align: middle; /* 2 */\n  }\n\n  /*\n  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  /*\n  1. Inherit font styles in all browsers.\n  2. Remove border radius in all browsers.\n  3. Remove background color in all browsers.\n  4. Ensure consistent opacity for disabled states in all browsers.\n*/\n\n  button,\n  input,\n  select,\n  optgroup,\n  textarea,\n  ::file-selector-button {\n    font: inherit; /* 1 */\n    font-feature-settings: inherit; /* 1 */\n    font-variation-settings: inherit; /* 1 */\n    letter-spacing: inherit; /* 1 */\n    color: inherit; /* 1 */\n    border-radius: 0; /* 2 */\n    background-color: transparent; /* 3 */\n    opacity: 1; /* 4 */\n  }\n\n  /*\n  Restore default font weight.\n*/\n\n  :where(select:is([multiple], [size])) optgroup {\n    font-weight: bolder;\n  }\n\n  /*\n  Restore indentation.\n*/\n\n  :where(select:is([multiple], [size])) optgroup option {\n    padding-inline-start: 20px;\n  }\n\n  /*\n  Restore space after button.\n*/\n\n  ::file-selector-button {\n    margin-inline-end: 4px;\n  }\n\n  /*\n  Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n*/\n\n  ::placeholder {\n    opacity: 1;\n  }\n\n  /*\n  Set the default placeholder color to a semi-transparent version of the current text color in browsers that do not\n  crash when using `color-mix(…)` with `currentcolor`. (https://github.com/tailwindlabs/tailwindcss/issues/17194)\n*/\n\n  @supports (not (-webkit-appearance: -apple-pay-button)) /* Not Safari */ or\n    (contain-intrinsic-size: 1px) /* Safari 17+ */ {\n    ::placeholder {\n      color: color-mix(in oklab, currentcolor 50%, transparent);\n    }\n  }\n\n  /*\n  Prevent resizing textareas horizontally by default.\n*/\n\n  textarea {\n    resize: vertical;\n  }\n\n  /*\n  Remove the inner padding in Chrome and Safari on macOS.\n*/\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  /*\n  1. Ensure date/time inputs have the same height when empty in iOS Safari.\n  2. Ensure text alignment can be changed on date/time inputs in iOS Safari.\n*/\n\n  ::-webkit-date-and-time-value {\n    min-height: 1lh; /* 1 */\n    text-align: inherit; /* 2 */\n  }\n\n  /*\n  Prevent height from changing on date/time inputs in macOS Safari when the input is set to `display: block`.\n*/\n\n  ::-webkit-datetime-edit {\n    display: inline-flex;\n  }\n\n  /*\n  Remove excess padding from pseudo-elements in date/time inputs to ensure consistent height across browsers.\n*/\n\n  ::-webkit-datetime-edit-fields-wrapper {\n    padding: 0;\n  }\n\n  ::-webkit-datetime-edit,\n  ::-webkit-datetime-edit-year-field,\n  ::-webkit-datetime-edit-month-field,\n  ::-webkit-datetime-edit-day-field,\n  ::-webkit-datetime-edit-hour-field,\n  ::-webkit-datetime-edit-minute-field,\n  ::-webkit-datetime-edit-second-field,\n  ::-webkit-datetime-edit-millisecond-field,\n  ::-webkit-datetime-edit-meridiem-field {\n    padding-block: 0;\n  }\n\n  /*\n  Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  /*\n  Correct the inability to style the border radius in iOS Safari.\n*/\n\n  button,\n  input:where([type=\"button\"], [type=\"reset\"], [type=\"submit\"]),\n  ::file-selector-button {\n    appearance: button;\n  }\n\n  /*\n  Correct the cursor style of increment and decrement buttons in Safari.\n*/\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /*\n  Make elements with the HTML hidden attribute stay hidden by default.\n*/\n\n  [hidden]:where(:not([hidden=\"until-found\"])) {\n    display: none !important;\n  }\n}\n\n@layer utilities {\n  @tailwind utilities;\n}\n","@import \"tailwindcss\";\n\nul {\n  list-style: disc;\n  padding-inline-start: 40px;\n}\n\n@layer components {\n  /** ---------------------------------------------\n   * It's from the design system\n   *  https://www.figma.com/design/bGbln5WpRxSxWaY8I4MLkX/Systeme.io-Design-System?node-id=3001-44542&m=dev\n   */\n  .text-heading-1 {\n    @apply text-black text-5xl font-semibold leading-[50px];\n  }\n  .text-heading-2 {\n    @apply text-black text-3xl font-semibold leading-[48px];\n  }\n  .text-heading-3 {\n    @apply text-black text-2xl font-semibold leading-loose;\n  }\n  .text-heading-4 {\n    @apply text-black text-xl font-semibold leading-7;\n  }\n  .text-heading-5 {\n    @apply text-black text-base font-semibold leading-normal;\n  }\n  .text-heading-6 {\n    @apply text-black text-sm font-semibold leading-tight;\n  }\n  .text-subheading-1 {\n    @apply text-black text-2xl font-medium leading-loose;\n  }\n  .text-subheading-2 {\n    @apply text-black text-xl font-medium leading-7;\n  }\n  .text-L {\n    @apply text-black text-base leading-normal;\n  }\n  .text-M {\n    @apply text-black text-sm leading-5;\n  }\n  .text-S {\n    @apply text-black text-xs leading-none;\n  }\n  .text-XS {\n    @apply text-black text-[10px] leading-none;\n  }\n\n  /*---------------------------------------------*/\n}\n.font-base {\n  font-family: \"Inter\", \"Helvetica\", \"Arial\", sans-serif;\n}\n\n@theme {\n  /** ---------------------------------------------\n   * It's from the design system\n   * https://www.figma.com/design/bGbln5WpRxSxWaY8I4MLkX/Systeme.io-Design-System?node-id=3002-805&p=f&vars=1&m=dev\n   */\n  --color-bgPrimaryBase: var(--color-white);\n  --color-bgSecondary: var(--color-gray-50);\n  --color-bgTertiary: var(--color-gray-100);\n  --color-bgQuaternary: var(--color-white);\n  --color-bgFocusNoFill: var(--color-alpha-gray-1);\n  --color-bgError: var(--color-error-100);\n  --color-bgWarning: var(--color-warning-100);\n  --color-bgSuccess: var(--color-success-100);\n\n  --color-textPrimary: var(--color-gray-900);\n  --color-textSecondary: var(--color-gray-700);\n  --color-textTertiary: var(--color-gray-500);\n  --color-textLink: var(--color-primary-500);\n  --color-textLinkHover: var(--color-primary-600);\n  --color-textLinkPressed: var(--color-primary-700);\n  --color-textDisabled: var(--color-gray-200);\n  --color-textError: var(--color-error-500);\n  --color-textWarning: var(--color-warning-500);\n  --color-textSuccess: var(--color-success-500);\n  --color-textOnColor: var(--color-white);\n\n  --color-btnPrimary: var(--color-primary-500);\n  --color-btnPrimaryHover: var(--color-primary-600);\n  --color-btnPrimaryPressed: var(--color-primary-700);\n  --color-btnDisabled: var(--color-gray-50);\n  --color-btnSecondary: var(--color-white);\n  --color-btnSecondaryBorder: var(--color-gray-200);\n  --color-btnSecondaryHover: var(--color-gray-50);\n  --color-btnSecondaryPressed: var(--color-gray-100);\n  --color-btnTertiary: var(--color-primary-50);\n  --color-btnTertiaryHover: var(--color-primary-100);\n  --color-btnTertiaryPressed: var(--color-primary-100);\n  --color-btnGhostPrimaryHover: var(--color-gray-50);\n  --color-btnGhostPrimaryPressed: var(--color-gray-100);\n\n  --color-inputBasePrimary: var(--color-white);\n  --color-inputBaseSecondary: var(--color-gray-50);\n  --color-inputBorder: var(--color-gray-200);\n  --color-inputBorderHover: var(--color-gray-300);\n  --color-inputBorderInteractive: var(--color-primary-500);\n  --color-inputBorderDisabled: var(--color-gray-150);\n  --color-inputBorderError: var(--color-error-500);\n\n  --color-border100: var(--color-gray-100);\n  --color-border200: var(--color-gray-150);\n  --color-border300: var(--color-gray-200);\n  --color-borderDisabled: var(--color-gray-150);\n  --color-borderInteractive: var(--color-primary-500);\n  --color-borderError: var(--color-error-500);\n  --color-borderWarning: var(--color-warning-500);\n  --color-borderSuccess: var(--color-success-500);\n\n  --color-iconPrimary: var(--color-primary-500);\n  --color-iconSecondary: var(--color-gray-700);\n  --color-iconTertiary: var(--color-gray-300);\n  --color-iconOnColor: var(--color-white);\n  --color-iconDisabled: var(--color-gray-150);\n  --color-iconError: var(--color-error-500);\n  --color-iconWarning: var(--color-warning-500);\n  --color-iconSuccess: var(--color-success-500);\n\n  --color-divider00: var(--color-gray-100);\n  --color-divider01: var(--color-gray-150);\n  --color-divider02: var(--color-gray-200);\n  --color-divider03: var(--color-gray-300);\n\n  --color-tagSoftPrimaryText: var(--color-primary-500);\n  --color-tagSoftPrimaryBg: var(--color-primary-100);\n  --color-tagSoftGrayText: var(--color-gray-900);\n  --color-tagSoftGrayBg: var(--color-gray-50);\n  --color-tagSoftPrimaryIcon: var(--color-primary-700);\n\n  /* Brand colors configured in the dashboard for white-label users */\n  --color-brandPrimary: var(--brand-primary);\n  --color-brandPrimaryHover: var(--brand-primary-hover);\n  --color-brandPrimaryPressed: var(--brand-primary-pressed);\n\n  --color-brandSecondary: var(--brand-secondary);\n  --color-brandSecondaryHover: var(--brand-secondary-hover);\n  --color-brandSecondaryPressed: var(--brand-secondary-pressed);\n\n  --color-brandTextPrimary: var(--brand-text-primary);\n  --color-brandTextSecondary: var(--brand-text-secondary);\n\n  --color-brandTextLink: var(--brand-text-link);\n  --color-brandTextLinkHover: var(--brand-text-link-hover);\n  --color-brandTextLinkPressed: var(--brand-text-link-pressed);\n\n  /**\n   * Don't use these colors directly! Use colors above\n   * TODO: remove unused colors later\n   */\n  --color-white: #FFFFFF;\n  --color-black: #000000;\n  --color-alpha-gray-1: #FFFFFF03;\n  --color-gray-50: #F2F2F3;\n  --color-gray-75: #ECECEE;\n  --color-gray-100: #E4E5E7;\n  --color-gray-150: #D7D8DA;\n  --color-gray-200: #CACBCE;\n  --color-gray-300: #B0B2B6;\n  --color-gray-400: #95989D;\n  --color-gray-500: #7B7E85;\n  --color-gray-600: #62656A;\n  --color-gray-700: #4A4C50;\n  --color-gray-800: #313235;\n  --color-gray-900: #19191B;\n  --color-gray-950: #0C0D0D;\n  --color-primary-50: #EFF8FE;\n  --color-primary-100: #DFF1FD;\n  --color-primary-200: #B9E5FC;\n  --color-primary-300: #7DD2FB;\n  --color-primary-400: #38BCF7;\n  --color-primary-500: #00A0FF;\n  --color-primary-600: #0286CA;\n  --color-primary-700: #0368A0;\n  --color-primary-800: #075884;\n  --color-primary-900: #0C496C;\n  --color-primary-950: #023F62;\n  --color-error-50: #FEF1F1;\n  --color-error-100: #FFE5E3;\n  --color-error-200: #FFCACA;\n  --color-error-300: #FDA1A1;\n  --color-error-400: #F86F6E;\n  --color-error-500: #EB4143;\n  --color-error-600: #D92625;\n  --color-error-700: #B51D1D;\n  --color-error-800: #971A1B;\n  --color-error-900: #7C1A1D;\n  --color-error-950: #721013;\n  --color-warning-50: #FEF9EA;\n  --color-warning-100: #FEF2C7;\n  --color-warning-200: #FEE68A;\n  --color-warning-300: #FDD14D;\n  --color-warning-400: #FCB823;\n  --color-warning-500: #F6970A;\n  --color-warning-600: #DB7005;\n  --color-warning-700: #B54D09;\n  --color-warning-800: #933C0E;\n  --color-warning-900: #79320E;\n  --color-warning-950: #6F2804;\n  --color-success-50: #EFFCF2;\n  --color-success-100: #D8F9E1;\n  --color-success-200: #ACF0C0;\n  --color-success-300: #7BE79C;\n  --color-success-400: #40D86E;\n  --color-success-500: #26BF56;\n  --color-success-600: #25A244;\n  --color-success-700: #077F2E;\n  --color-success-800: #00601A;\n  --color-success-900: #10451D;\n  --color-success-950: #063B13;\n  /*---------------------------------------------*/\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
